import React, { useState, useEffect, useRef, useCallback } from "react";
import DayCard from "./DayCard ";
import AddDayPopup from "./AddDayPopup";
import { useNavigate, useLocation } from "react-router-dom"; // Import useNavigate
import '@fortawesome/fontawesome-free/css/all.min.css';
import { makeAuthenticatedRequest } from "../utils/apiRequest";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { useAuth } from "../contexts/authContext";
import LoadingScreen from "./pages/LoadingScreen";
import CustomAlert from "./CustomAlert"; // Add this import
import { useCustomAlert } from "./useCustomAlert"; // Add this import

// Add custom animation styles
const fadeInAnimation = `
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
}
.animate-fadeIn {
  animation: fadeIn 0.3s ease-out forwards;
}
`;

// Add style tag to document head
if (typeof document !== 'undefined') {
  const styleEl = document.createElement('style');
  styleEl.type = 'text/css';
  styleEl.appendChild(document.createTextNode(fadeInAnimation));
  document.head.appendChild(styleEl);
}



const DayManager = () => {
  const [days, setDays] = useState([]);
  const [availableCities, setAvailableCities] = useState([]);
  const [isLoadingCities, setIsLoadingCities] = useState(false);
  const [error, setError] = useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [selectedCustomerId, setSelectedCustomerId] = useState("");
  const [selectedCustomerName, setSelectedCustomerName] = useState("");
  const location = useLocation();
  const { token, currentUser } = useAuth();
  const navigate = useNavigate(); // Initialize navigate
  const [editData, setEditData] = useState(location.state?.editData || null);
  const dayRefs = useRef([]); // Array of refs for each day
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isGenerating, setIsGenerating] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const [numAdults, setNumAdults] = useState("");
const [numChildren, setNumChildren] = useState("");
const [roomCount, setRoomCount] = useState("");
const [roomCategory, setRoomCategory] = useState("");
const [vehicleType, setVehicleType] = useState("");
const [roomCategories, setRoomCategories] = useState([]);
const [vehicleTypes, setVehicleTypes] = useState([]);
const [isLoadingVehicles, setIsLoadingVehicles] = useState(false);
const [selectedVehicleDetails, setSelectedVehicleDetails] = useState(null);
const [roomType, setRoomType] = useState("");

const [bookingType, setBookingType] = useState("period"); // "period" or "date"
const [bookingStartDate, setBookingStartDate] = useState("");
const [bookingEndDate, setBookingEndDate] = useState("");
const [specificBookingDate, setSpecificBookingDate] = useState("");


const [selectedRoomCategory, setSelectedRoomCategory] = useState("");

const [marketType, setMarketType] = useState("");
const [isMarketTypeDropdownOpen, setIsMarketTypeDropdownOpen] = useState(false);
const [marketTypeSearchQuery, setMarketTypeSearchQuery] = useState("");

const marketTypes = [
  "All",
  "Asian",
 
];




  const [isEditing, setIsEditing] = useState(false); // For tracking edit mode
  const hasActivities = days.some((day) =>
    day.citiesWithActivities.some((city) => city.activities.length > 0)
  );
  const [isLoading, setIsLoading] = useState(false);
  const [showLoadingOverlay, setShowLoadingOverlay] = useState(false);

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);  // Handle dropdown visibility
const [searchQuery, setSearchQuery] = useState("");  // State for search query



const [vehicleSearchQuery, setVehicleSearchQuery] = useState("");  // State for vehicle search query
const [isVehicleDropdownOpen, setIsVehicleDropdownOpen] = useState(false);  // Toggle vehicle dropdown visibility

const [isDetailsPopupOpen, setIsDetailsPopupOpen] = useState(false);

// Add state for hotel selection
const [selectedHotel, setSelectedHotel] = useState(null);
const [selectedCity, setSelectedCity] = useState('');
const [allHotelsCollection, setAllHotelsCollection] = useState([]);

// Add state for tax data
const [taxData, setTaxData] = useState([]);
const [rates, setRates] = useState([]); // Add state for rates array

// Add this after your existing state declarations
const { alertConfig, showSuccess, showError, showWarning, showConfirm } = useCustomAlert();

// Function to fetch rates (currencies)
const fetchRates = useCallback(async () => {
  try {
    const response = await makeAuthenticatedRequest(
      "https://us-central1-evoq-travel-craft.cloudfunctions.net/get_all_currency",
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    if (!response.ok) throw new Error("Failed to fetch rates data.");
    const data = await response.json();
    // Format as array of { currency_name, value }
    const formattedRates = (data.data || []).map(rate => ({
      currency_name: rate.currency_name,
      value: rate.value !== undefined ? rate.value : (rate.currency_value !== undefined ? rate.currency_value : null)
    }));
    setRates(formattedRates);
    return formattedRates;
  } catch (error) {
    console.error("Error fetching rates data:", error.message);
    setRates([]);
    return [];
  }
}, [token]);

// Function to fetch tax data - memoized with useCallback
const fetchTaxes = useCallback(async () => {
  try {
    const response = await makeAuthenticatedRequest(
      "https://us-central1-evoq-travel-craft.cloudfunctions.net/get_all_taxes",
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) throw new Error("Failed to fetch tax data.");

    const data = await response.json();
    if (data && data.data && Array.isArray(data.data)) {
      // Format tax data as needed for the output JSON
      const formattedTaxData = data.data.map(tax => ({
        tax_name: tax.tax_name || "Tax",
        tax_percentage: parseFloat(tax.tax_percentage) || 0
      }));
      setTaxData(formattedTaxData);
      console.log("Tax Data fetched:", formattedTaxData);
    }
  } catch (error) {
    console.error("Error fetching tax data:", error.message);
  }
}, [token]);


// Fetch tax data when component mounts
useEffect(() => {
  fetchTaxes();
}, [token, fetchTaxes]);

useEffect(() => {
  if (editData && editData.days) {
      // Set customer details
     setSelectedCustomerId(editData.customer_id || "");
      setSelectedCustomerName(editData.customerName || "");

      // Populate booking details if they exist
      if (editData.bookingDetails) {
          console.log("Full Booking Details from editData:", JSON.stringify(editData.bookingDetails, null, 2));

          setNumAdults(editData.bookingDetails.numAdults || "");
          setNumChildren(editData.bookingDetails.numChildren || "");
          setRoomCount(editData.bookingDetails.roomCount || "");
          setRoomCategory(editData.bookingDetails.roomCategory || "");
          setMarketType(editData.bookingDetails.marketType || "");
          
          // Add these new lines for booking period/date
          setBookingType(editData.bookingDetails.bookingType || "period");
          setBookingStartDate(editData.bookingDetails.bookingStartDate || "");
          setBookingEndDate(editData.bookingDetails.bookingEndDate || "");
          setSpecificBookingDate(editData.bookingDetails.specificBookingDate || "");

          if (editData.bookingDetails.vehicleDetails) {
              const vehicleDetails = editData.bookingDetails.vehicleDetails;
              setSelectedVehicleDetails(vehicleDetails);
              setVehicleType(vehicleDetails.vehicleType || "");
              console.log("Vehicle Type set from editData:", vehicleDetails.vehicleType);
          } else {
              console.warn("Warning: vehicleDetails is missing in bookingDetails!");
              setSelectedVehicleDetails(null);
              setVehicleType("");
          }
      }
      const processedDays = editData.days.map((day, index) => {
          // Process selected hotels
          if (day.selected_hotels && day.selected_hotels.length > 0) {
              day.selected_hotels.forEach(hotel => {
                  const key = `${index + 1}-${hotel.city}-${hotel.rating}`;
                  console.log("Hotel Details: ", {
                    hotel_id: hotel.hotel_id,
                    name: hotel.hotel_name,
                    rating: hotel.rating,
                    city: hotel.city,
                    dayId: index + 1,
                    dayNumber: day.day_number,
                    selectedRoomType: hotel.selected_room_type || "", // Ensure room type is set
                    selectedType: hotel.selected_type || "", // Ensure type is set
                    room_types: hotel.room_types || [], // Include room types array
                    types: hotel.types || [] // Include types array
                  });
                 
                
                  setSelectedHotelsMap(prev => ({
                      ...prev,
                      [key]: {
                          hotel_id: hotel.hotel_id,
                          name: hotel.hotel_name,
                          rating: hotel.rating,
                          city: hotel.city,
                          dayId: index + 1,
                          dayNumber: day.day_number,
                          selectedRoomType: hotel.selected_room_type || null,
                          selectedType: hotel.selected_type || null,
                          room_types: hotel.room_types || [], // Include room types array
                types: hotel.types || [] // Include types array
                      }
                  }));

                  // Add the rating to selectedRatings if not already present
                  setSelectedRatings(prev => {
                      if (!prev.includes(hotel.rating)) {
                          return [...prev, hotel.rating].sort((a, b) => b - a);
                      }
                      return prev;
                  });
              });
          }

          // Process cities with activities
          const citiesWithActivities = (day.city || []).map((city) => {
              const activitiesForCity = (day.activity || []).filter((activity) => {
                  if (!activity.city || activity.city.trim() === "") {
                      return city.city_name === day.city[0]?.city_name;
                  }
                  return activity.city === city.city_name;
              }).map(activity => {
                  // Extract ticket data if it exists
                  let ticketCategory = "";
                  let ticketPrice = "";
                  
                  if (activity.tickets && typeof activity.tickets === 'object') {
                      const ticketKeys = Object.keys(activity.tickets);
                      if (ticketKeys.length > 0) {
                          ticketCategory = ticketKeys[0];
                          ticketPrice = activity.tickets[ticketCategory];
                      }
                  }
                  
                  return {
                      ...activity,
                      activity_type: activity.activity_type || "unknown",
                      ticketCategory: ticketCategory,
                      ticketPrice: ticketPrice,
                      tickets_price: activity.tickets_price || false,
                      ticketAvailability: activity.ticketAvailability || false
                  };
              });

              return {
                  city_id: city.city_id || index.toString(),
                  city: city.city_name,
                  city_description: city.city_description || "",
                  city_image: city.city_image || "",
                  activities: activitiesForCity
              };
          });

          return {
              id: index + 1,
              number: day.day_number,
              date: day.calander_date,
              type: day.type_of_day,
              citiesWithActivities
          };
      });

      setDays(processedDays);
  }
}, [editData]);




// --- Centralized handler for updating sightseeing activities in a day/city ---
/**
 * Updates sightseeing activities for a specific day and city.
 * Ensures that costing is always recalculated after changes.
 * @param {number} dayId - The id of the day to update.
 * @param {string} cityId - The city_id of the city to update.
 * @param {Array} newActivities - The new array of activities for the city.
 */
const updateSightseeingActivitiesForDay = (dayId, cityId, newActivities) => {
  setDays(prevDays => {
    const newDays = prevDays.map(day => {
      if (day.id !== dayId) return day;
      return {
        ...day,
        citiesWithActivities: day.citiesWithActivities.map(city =>
          city.city_id === cityId
            ? { ...city, activities: newActivities }
            : city
        )
      };
    });
    return newDays;
  });
};

// --- Centralized handler for updating checkin activities in a day/city ---
/**
 * Updates checkin activities for a specific day and city.
 * Ensures that accommodation details are always recalculated after changes.
 * @param {number} dayId - The id of the day to update.
 * @param {string} cityId - The city_id of the city to update.
 * @param {Array} newActivities - The new array of activities for the city.
 */
const updateCheckinActivitiesForDay = (dayId, cityId, newActivities) => {
  setDays(prevDays => {
    const newDays = prevDays.map(day => {
      if (day.id !== dayId) return day;
      return {
        ...day,
        citiesWithActivities: day.citiesWithActivities.map(city =>
          city.city_id === cityId
            ? { ...city, activities: newActivities }
            : city
        )
      };
    });
    return newDays;
  });
};

// --- Usage Example ---
// updateSightseeingActivitiesForDay(dayId, cityId, updatedActivitiesArray);
// updateCheckinActivitiesForDay(dayId, cityId, updatedActivitiesArray);
//
// Refactor all add/edit/delete sightseeing and checkin activity logic to use these handlers for consistency.
// This ensures sightseeing_costing and accommodation arrays are always in sync with the activities.

// --- Generate accommodation array from days state ---
function generateAccommodationDetails(days) {
  // This function collects all checkin activities and maps them to the accommodation array format
  // Adjust the mapping logic as per your accommodation structure requirements
  const accommodation = [];
  days.forEach(day => {
    day.citiesWithActivities.forEach(city => {
      city.activities
        .filter(activity => activity.activity_type === "checkin")
        .forEach(activity => {
          accommodation.push({
            day: `Day ${String(day.number).padStart(2, '0')}`,
            calendar_date: day.date || "Not Selected",
            city: city.city,
            hotel_name: activity.hotel_name || null,
            hotel_id: activity.hotel_id || null,
            roomType: activity.roomType || null,
            mealPlan: activity.mealPlan || null,
            // Add more fields as needed
          });
        });
    });
  });
  return accommodation;
}

// --- State for accommodation array, always synced ---
const [accommodationDetails, setAccommodationDetails] = useState([]);

useEffect(() => {
  setAccommodationDetails(generateAccommodationDetails(days));
}, [days]);





  const fetchCustomers = async () => {
    if (!token) {
      setError("Authorization token is missing.");
      return;
    }

    try {
      const response = await makeAuthenticatedRequest(
        "https://us-central1-evoq-travel-craft.cloudfunctions.net/get_customer_data",
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error(`Error fetching customers: ${response.statusText}`);
      }

      const data = await response.json();
      setCustomers(data.data || []);
    } catch (err) {
      setError("Failed to fetch customers. Please try again.");
    }
  };

  useEffect(() => {
    fetchCustomers();
  }, [token]);

  const handleCustomerSelect = (event) => {
    const selectedId = event.target.value;
    const selectedCustomer = customers.find(
      (customer) => customer.customer_id === selectedId
    );

    setSelectedCustomerId(selectedId);
    setSelectedCustomerName(selectedCustomer?.name || "Unknown Customer");
  };

  const openAddDayPopup = () => setIsPopupOpen(true);

  const closeAddDayPopup = () => setIsPopupOpen(false);

  // When adding a day, always use the callback form of setDays to ensure itinerary_cost updates reliably
  const handleAddDay = (dayDetails) => {
    setDays(prevDays => {
      const newDay = {
        id: Date.now(),
        number: prevDays.length + 1,
        date: dayDetails.date,
        type: dayDetails.type,
        citiesWithActivities: [],
      };
      return [...prevDays, newDay];
    });
  };


  // --- Handler to robustly add a city to a day and ensure costing updates ---
/**
 * Adds a city to a specific day in the itinerary.
 * Always uses the callback form of setDays to avoid state staleness.
 * @param {number} dayId - The id of the day to update.
 * @param {object} newCity - The new city object to add (should have city_id, city, etc.)
 */
const handleAddCityToDay = (dayId, newCity) => {
  setDays(prevDays =>
    prevDays.map(day =>
      day.id === dayId
        ? {
            ...day,
            citiesWithActivities: [
              ...day.citiesWithActivities,
              {
                ...newCity,
                activities: [] // Always initialize activities
              }
            ]
          }
        : day
    )
  );
};

// onUpdateDay can remain for bulk updates, but for sightseeing activities, use updateSightseeingActivitiesForDay
  const onUpdateDay = (dayId, updatedCitiesWithActivities, updatedDetails = {}) => {
    setDays((prevDays) => {
      // Find the day being updated
      const updatedDayIndex = prevDays.findIndex(day => day.id === dayId);
      if (updatedDayIndex === -1) return prevDays;
      
      // Create a copy of the days array
      const newDays = [...prevDays];
      
      // Update the specific day first
      newDays[updatedDayIndex] = {
        ...newDays[updatedDayIndex],
        citiesWithActivities: updatedCitiesWithActivities.map((city) => ({
          ...city,
          activities: city.activities.map((activity) => ({
            activity_type: activity.activity_type || "unknown", // Ensure activity_type exists
            ...activity,
          })),
        })),
        type: updatedDetails.type || newDays[updatedDayIndex].type,
        date: updatedDetails.date || newDays[updatedDayIndex].date,
      };
      
      // If autoUpdateDates flag is set, update all other days' dates relative to the changed date
      if (updatedDetails.autoUpdateDates && updatedDetails.date) {
        const changedDate = new Date(updatedDetails.date);
        const dayNumber = updatedDetails.dayNumber || newDays[updatedDayIndex].number;
        
        // Update dates for all days based on the changed date
        newDays.forEach((day, index) => {
          if (day.id !== dayId) { // Skip the day that was directly updated
            // Calculate date difference based on day numbers
            const dayDiff = day.number - dayNumber;
            
            // Create a new date by adding/subtracting days from the changed date
            const newDate = new Date(changedDate);
            newDate.setDate(changedDate.getDate() + dayDiff);
            
            // Format the date as YYYY-MM-DD
            const formattedDate = newDate.toISOString().split('T')[0];
            
            // Update the date for this day
            newDays[index] = {
              ...newDays[index],
              date: formattedDate
            };
          }
        });
      }

      // --- Force itineraryCost recalculation after every update ---
      setTimeout(() => {
        setItineraryCost(generateItineraryCost(newDays, numAdults, numChildren, taxData));
      }, 0);
      
      return newDays;
    });
  };

  // --- All sightseeing activity changes should use updateSightseeingActivitiesForDay for costing sync ---

  
  
  
  


 // Function to remove null, empty strings, and empty arrays recursively
const removeNullValues = (obj) => {
  if (Array.isArray(obj)) {
    return obj.map(removeNullValues).filter(item => item !== null && item !== "" && !(Array.isArray(item) && item.length === 0));
  } else if (typeof obj === "object" && obj !== null) {
    return Object.fromEntries(
      Object.entries(obj)
        .filter(([_, value]) => value !== null && value !== "" && !(Array.isArray(value) && value.length === 0))
        .map(([key, value]) => [key, removeNullValues(value)])
    );
  }
  return obj;
};

// --- Helper to generate itinerary cost from current state ---
function generateItineraryCost(days, numAdults, numChildren, taxData) {
  const ticketPriceData = days.map(day => {
    const citiesWithActivities = {};
    let hasSightseeing = false;
    day.citiesWithActivities.forEach(city => {
      const sightseeingActivities = city.activities
        .filter(activity =>
          activity.activity_type === "sightseeing" &&
          (activity.ticketCategory || activity.tickets_price || activity.ticketAvailability)
        )
        .map(activity => {
          let adultPrice = 0;
          let childrenPrice = 0;
          if (activity.ticketPrice && typeof activity.ticketPrice === 'object') {
            adultPrice = parseFloat(activity.ticketPrice.adults?.replace('$', '')) || 0;
            childrenPrice = parseFloat(activity.ticketPrice.children?.replace('$', '')) || 0;
          } else {
            adultPrice = parseFloat(String(activity.ticketPrice).replace('$', '')) || 0;
            childrenPrice = 0;
          }
          const numAdultsValue = parseInt(numAdults) || 0;
          const numChildrenValue = parseInt(numChildren) || 0;
          const totalPrice = (adultPrice * numAdultsValue) + (childrenPrice * numChildrenValue);

          let totalPriceWithTax = totalPrice;
          let taxDetails = [];
          if (activity.taxedPrices && typeof activity.taxedPrices === 'object') {
            const category = activity.ticketCategory || Object.keys(activity.taxedPrices)[0];
            if (category && activity.taxedPrices[category]) {
              const adultsTaxedPrice = parseFloat(activity.taxedPrices[category].adults_with_tax || 0);
              const childrenTaxedPrice = parseFloat(activity.taxedPrices[category].children_with_tax || 0);
              totalPriceWithTax = (adultsTaxedPrice * numAdultsValue) + (childrenTaxedPrice * numChildrenValue);
              const adultTaxAmount = adultsTaxedPrice - adultPrice;
              const childrenTaxAmount = childrenTaxedPrice - childrenPrice;
              if (activity.taxDetails && activity.taxDetails.length > 0) {
                activity.taxDetails.forEach(tax => {
                  taxDetails.push({
                    tax_name: tax.tax_name || 'Tax',
                    tax_percentage: tax.tax_percentage || 0,
                    tax_amount: Math.round((adultTaxAmount * numAdultsValue) + (childrenTaxAmount * numChildrenValue))
                  });
                });
              }
            } else {
              totalPriceWithTax = activity.taxedPrices.totalWithTax || totalPrice;
              taxDetails = activity.taxedPrices.appliedTaxes || [];
            }
          } else if (activity.taxAvailable && activity.taxDetails && activity.taxDetails.length > 0) {
            let taxAmount = 0;
            activity.taxDetails.forEach(tax => {
              const taxValue = (totalPrice * (tax.tax_percentage / 100));
              taxAmount += taxValue;
              taxDetails.push({
                tax_name: tax.tax_name,
                tax_percentage: tax.tax_percentage,
                tax_amount: Math.round(taxValue)
              });
            });
            totalPriceWithTax = totalPrice + taxAmount;
          }
          return {
            "location_name": activity.location_name || "",
            "location_total_ticket_price": totalPrice > 0 ? parseFloat(totalPrice).toFixed(2) : "0.00",
            "with_tax_location_total_ticket_price": totalPriceWithTax > 0 ? parseFloat(totalPriceWithTax).toFixed(2) : "0.00",
            "location_visit_adults_n_children_count": {
              "no_of_adults": numAdults || "0",
              "no_of_children": numChildren || "0"
            },
            "ticket_prices": {
              "adult_ticket_price": {
                "currency": "$",
                "value": adultPrice > 0 ? parseFloat(adultPrice).toFixed(2) : "0.00"
              },
              "children_ticket_price": {
                "currency": childrenPrice > 0 ? "$" : "Not Selected",
                "value": childrenPrice > 0 ? parseFloat(childrenPrice).toFixed(2) : "0.00"
              }
            },
            "taxed_prices": {
              "adult_with_tax": activity.taxedPrices && activity.ticketCategory && activity.taxedPrices[activity.ticketCategory] ? 
                parseFloat(activity.taxedPrices[activity.ticketCategory].adults_with_tax || 0).toFixed(2) : "0.00",
              "children_with_tax": activity.taxedPrices && activity.ticketCategory && activity.taxedPrices[activity.ticketCategory] ? 
                parseFloat(activity.taxedPrices[activity.ticketCategory].children_with_tax || 0).toFixed(2) : "0.00"
            },
            "tickets_country_category": activity.ticketCategory || "Not Selected",
            "taxAvailable": activity.taxAvailable || false,
            "taxDetails": taxDetails.map(tax => ({ tax_name: tax.tax_name }))
          };
        });
      // Always create a costing entry for every city, even if there are no sightseeing activities
      if (!citiesWithActivities[city.city]) {
        citiesWithActivities[city.city] = [];
      }
      if (sightseeingActivities.length > 0) {
        hasSightseeing = true;
        citiesWithActivities[city.city].push(...sightseeingActivities);
      }
    });
    let dayTotalCost = 0;
    let dayTotalCostWithTax = 0;
    Object.values(citiesWithActivities).forEach(activities => {
      activities.forEach(activity => {
        const rawCost = activity.location_total_ticket_price;
        const rawCostWithTax = activity.with_tax_location_total_ticket_price;
        const numCost = typeof rawCost === 'string' ? parseFloat(rawCost) : parseFloat(rawCost);
        const numCostWithTax = typeof rawCostWithTax === 'string' ? parseFloat(rawCostWithTax) : parseFloat(rawCostWithTax);
        dayTotalCost += isNaN(numCost) ? 0 : numCost;
        dayTotalCostWithTax += isNaN(numCostWithTax) ? 0 : numCostWithTax;
      });
    });
    // Now, always create a costing entry for every city in this day
    const cityEntries = day.citiesWithActivities.map(city => {
      return {
        "day": `Day ${String(day.number).padStart(2, '0')}`,
        "calendar_date": day.date || "Not Selected",
        "city": city.city,
        "sightseeing_costing": citiesWithActivities[city.city] || [],
        "day_total_cost": dayTotalCost.toFixed(2),
        "day_total_cost_with_tax": dayTotalCostWithTax.toFixed(2)
      };
    });
    // Always return an entry for the day, even if there are no cities
    if (cityEntries.length === 0) {
      return {
        "day": `Day ${String(day.number).padStart(2, '0')}`,
        "calendar_date": day.date || "Not Selected",
        "city": "Unknown",
        "sightseeing_costing": [],
        "day_total_cost": "0.00",
        "day_total_cost_with_tax": "0.00"
      };
    }
    return cityEntries;
  });
  const flattenedTicketPriceData = ticketPriceData.flat();
  flattenedTicketPriceData.forEach(entry => {
    entry.taxes = taxData;
    if (Array.isArray(entry.sightseeing_costing)) {
      entry.sightseeing_costing.forEach(costing => {
        if (costing.location_visit_adults_n_children_count) {
          costing.location_visit_adults_n_children_count.no_of_adults = numAdults || "0";
          costing.location_visit_adults_n_children_count.no_of_children = numChildren || "0";
        }
      });
    }
  });
  return flattenedTicketPriceData;
}

// --- State for itinerary cost, always synced ---
const [itineraryCost, setItineraryCost] = useState([]);

useEffect(() => {
  setItineraryCost(generateItineraryCost(days, numAdults, numChildren, taxData));
}, [days, numAdults, numChildren, taxData]);

// Format Itinerary Data
const formatItineraryData = (ratesArg) => { 
  const formattedDays = days.map((day, index) => {
    // Check if this is the last day - if so, don't include selected hotels
    const isLastDay = index === days.length - 1;
    
    // Get selected hotels for this day (empty for last day)
    const daySelectedHotels = isLastDay ? [] : Object.values(selectedHotelsMap)
    .filter(hotel => hotel.dayId === day.id && selectedRatings.includes(hotel.rating))
    .map(hotel => ({
      hotel_id: hotel.hotel_id,
      hotel_name: hotel.name,
      rating: hotel.rating,
      city: hotel.city === "Uncategorized" ? day.citiesWithActivities[0]?.city || hotel.city : hotel.city,
      selected_room_type: hotel.selectedRoomType || "",  // Ensure this is included
      selected_type: hotel.selectedType || ""  // Ensure this is included
    }));
  
      
    return {
      day_number: String(day.number),
      calander_date: day.date,
      type_of_day: day.type,
      selected_hotels: daySelectedHotels.length > 0 ? daySelectedHotels : undefined,
      city: day.citiesWithActivities.map((city) => ({
        city_id: city.city_id || "C001",
        city_name: city.city,
        city_description: city.city_description || "",
        city_image: Array.isArray(city.city_image)
          ? city.city_image
          : [city.city_image || ""],
      })),
      activity: day.citiesWithActivities.flatMap((city) =>
        city.activities.map((activity) => {
          // Always create tickets object if ticketCategory and ticketPrice exist,
          // even if they are empty strings (this preserves the structure)
          let tickets = null;
          if (activity.ticketCategory && activity.ticketPrice) {
            // Handle new ticket price structure with separate prices for adults and children
            if (typeof activity.ticketPrice === 'object' && (activity.ticketPrice.adults || activity.ticketPrice.children)) {
              tickets = {
                [activity.ticketCategory]: activity.ticketPrice
              };
            } else {
              // Fallback to the old format if ticketPrice is a string
              tickets = {
                [activity.ticketCategory]: activity.ticketPrice
              };
            }
          }

          return {
            activity_type: activity.activity_type,
            city: city.city,
            inclusion: activity.inclusion === true,
            arrangement: activity.arrangement || "Own Arrangement",
            hotel_name: activity.hotel_name || null,
            hotel_id: activity.hotel_id || null,
            mealPlan: activity.mealPlan || null,
            roomType: activity.roomType || null,
            restaurant_name: activity.restaurant_name || null,
            meal: activity.meal || null,
            location_name: activity.location_name || null,
            location_id: activity.location_id || null,
            location_img_path: activity.location_img_path || [],
            description: activity.description || null,
            type: activity.type || "Optional",
            tickets: tickets, // Include tickets object whether null or with values
            tickets_price: activity.tickets_price || false,
            ticketAvailability: activity.ticketAvailability || false,
            taxAvailable: activity.taxAvailable || false,
taxDetails: activity.taxDetails || [], // Include specific tax details from the attractions

            // Also include the individual ticket fields to ensure they're preserved in state
            ticketCategory: activity.ticketCategory || null,
            ticketPrice: activity.ticketPrice || null,
            taxedPrices: activity.taxedPrices || null // Include the calculated tax prices
          };
        })
      ),
    };
  });

  // Create itinerary_cost array for sightseeing activities
  const ticketPriceData = days.map(day => {
    // Group activities by city for this day
    const citiesWithActivities = {};
    
    // First, collect all activities for each city in this day
    day.citiesWithActivities.forEach(city => {
      // Filter only sightseeing activities that have ticket information
      const sightseeingActivities = city.activities
        .filter(activity => 
          activity.activity_type === "sightseeing" && 
          (activity.ticketCategory || activity.tickets_price || activity.ticketAvailability)
        )
        .map(activity => {
          // Calculate total price based on adults and children
          let adultPrice = 0;
          let childrenPrice = 0;
          
          // Handle new ticket price structure with separate prices for adults and children
          if (activity.ticketPrice && typeof activity.ticketPrice === 'object') {
            // Extract adult and children prices from the object
            adultPrice = parseFloat(activity.ticketPrice.adults?.replace('$', '')) || 0;
            childrenPrice = parseFloat(activity.ticketPrice.children?.replace('$', '')) || 0;
          } else {
            // Fallback to the old format if ticketPrice is a string
            adultPrice = parseFloat(String(activity.ticketPrice).replace('$', '')) || 0;
            childrenPrice = 0; // No children price in old format
          }
          
          const numAdultsValue = parseInt(numAdults) || 0;
          const numChildrenValue = parseInt(numChildren) || 0;
          const totalPrice = (adultPrice * numAdultsValue) + (childrenPrice * numChildrenValue);
          
          console.log(`Calculating total price for ${activity.location_name}: ${adultPrice} × ${numAdultsValue} adults + ${childrenPrice} × ${numChildrenValue} children = ${totalPrice}`);
          
          // Calculate price with tax using taxedPrices directly
          let totalPriceWithTax = totalPrice;
          let taxDetails = [];
          
          if (activity.taxedPrices && typeof activity.taxedPrices === 'object') {
            // Get the ticket category
            const category = activity.ticketCategory || Object.keys(activity.taxedPrices)[0];
            
            if (category && activity.taxedPrices[category]) {
              // Extract adults_with_tax and children_with_tax values
              const adultsTaxedPrice = parseFloat(activity.taxedPrices[category].adults_with_tax || 0);
              const childrenTaxedPrice = parseFloat(activity.taxedPrices[category].children_with_tax || 0);
              
              // Calculate total with tax based on adults and children count
              const numAdultsValue = parseInt(numAdults) || 0;
              const numChildrenValue = parseInt(numChildren) || 0;
              totalPriceWithTax = (adultsTaxedPrice * numAdultsValue) + (childrenTaxedPrice * numChildrenValue);
              
              // Build tax details
              const adultTaxAmount = adultsTaxedPrice - adultPrice;
              const childrenTaxAmount = childrenTaxedPrice - childrenPrice;
              
              if (activity.taxDetails && activity.taxDetails.length > 0) {
                activity.taxDetails.forEach(tax => {
                  taxDetails.push({
                    tax_name: tax.tax_name || 'Tax',
                    tax_percentage: tax.tax_percentage || 0,
                    tax_amount: Math.round((adultTaxAmount * numAdultsValue) + (childrenTaxAmount * numChildrenValue))
                  });
                });
              }
              
              console.log(`Using taxed prices for ${activity.location_name}: adults ${adultPrice} -> ${adultsTaxedPrice}, children ${childrenPrice} -> ${childrenTaxedPrice}, total: ${totalPriceWithTax}`);
            } else {
              // Fallback to old format if category not found
              totalPriceWithTax = activity.taxedPrices.totalWithTax || totalPrice;
              taxDetails = activity.taxedPrices.appliedTaxes || [];
              console.log(`Using old taxed price format for ${activity.location_name}: ${totalPrice} + tax = ${totalPriceWithTax}`);
            }
          } else if (activity.taxAvailable && activity.taxDetails && activity.taxDetails.length > 0) {
            // Calculate tax manually if taxedPrices is not available but taxDetails is
            let taxAmount = 0;
            activity.taxDetails.forEach(tax => {
              const taxValue = (totalPrice * (tax.tax_percentage / 100));
              taxAmount += taxValue;
              taxDetails.push({
                tax_name: tax.tax_name,
                tax_percentage: tax.tax_percentage,
                tax_amount: Math.round(taxValue)
              });
            });
            totalPriceWithTax = totalPrice + taxAmount;
            console.log(`Calculated tax for ${activity.location_name}: ${totalPrice} + ${taxAmount} = ${totalPriceWithTax}`);
          }
          
          return {
            "location_name": activity.location_name || "",
            "location_total_ticket_price": totalPrice > 0 ? parseFloat(totalPrice).toFixed(2) : "0.00",
            "with_tax_location_total_ticket_price": totalPriceWithTax > 0 ? parseFloat(totalPriceWithTax).toFixed(2) : "0.00",
            "location_visit_adults_n_children_count": {
              "no_of_adults": numAdults || "0",
              "no_of_children": numChildren || "0"
            },
            "ticket_prices": {
              "adult_ticket_price": {
                "currency": "$",
                "value": adultPrice > 0 ? parseFloat(adultPrice).toFixed(2) : "0.00"
              },
              "children_ticket_price": {
                "currency": childrenPrice > 0 ? "$" : "Not Selected",
                "value": childrenPrice > 0 ? parseFloat(childrenPrice).toFixed(2) : "0.00"
              }
            },
            "taxed_prices": {
              "adult_with_tax": activity.taxedPrices && activity.ticketCategory && activity.taxedPrices[activity.ticketCategory] ? 
                parseFloat(activity.taxedPrices[activity.ticketCategory].adults_with_tax || 0).toFixed(2) : "0.00",
              "children_with_tax": activity.taxedPrices && activity.ticketCategory && activity.taxedPrices[activity.ticketCategory] ? 
                parseFloat(activity.taxedPrices[activity.ticketCategory].children_with_tax || 0).toFixed(2) : "0.00"
            },
            "tickets_country_category": activity.ticketCategory || "Not Selected",
            "taxAvailable": activity.taxAvailable || false,
            "taxDetails": taxDetails.map(tax => ({ tax_name: tax.tax_name })) // Only include tax_name for each tax
          };
        });
      
      if (sightseeingActivities.length > 0) {
        if (!citiesWithActivities[city.city]) {
          citiesWithActivities[city.city] = [];
        }
        citiesWithActivities[city.city].push(...sightseeingActivities);
      }
    });
    
    // Calculate day total cost (both with and without tax)
    // Initialize with explicit numeric 0
    let dayTotalCost = 0; 
    let dayTotalCostWithTax = 0;
    
    // Process each activity and ensure proper numeric addition
    Object.values(citiesWithActivities).forEach(activities => {
      activities.forEach(activity => {
        // Force conversion to numbers using parseFloat() and handle any NaN
        const rawCost = activity.location_total_ticket_price;
        const rawCostWithTax = activity.with_tax_location_total_ticket_price;
        
        // First convert string to number (proper handling for decimals)
        const numCost = typeof rawCost === 'string' ? parseFloat(rawCost) : parseFloat(rawCost);
        const numCostWithTax = typeof rawCostWithTax === 'string' ? parseFloat(rawCostWithTax) : parseFloat(rawCostWithTax);
        
        // Add using numeric addition with proper NaN handling
        dayTotalCost += isNaN(numCost) ? 0 : numCost;
        dayTotalCostWithTax += isNaN(numCostWithTax) ? 0 : numCostWithTax;
        
        // Debug the values to ensure they're numeric
        console.log(`Adding activity ${activity.location_name}: ${numCost} (base) / ${numCostWithTax} (with tax), running totals: ${dayTotalCost} / ${dayTotalCostWithTax}`);
        
        console.log(`Adding activity ${activity.location_name}: ${numCost} (base) / ${numCostWithTax} (with tax)`);
      });
    });
    
    console.log(`Day ${day.number} totals: ${dayTotalCost} (base) / ${dayTotalCostWithTax} (with tax)`);
    
    // Create entry for each city in this day
    const cityEntries = Object.keys(citiesWithActivities).map(cityName => {
      return {
        "day": `Day ${String(day.number).padStart(2, '0')}`,
        "calendar_date": day.date || "Not Selected",
        "city": cityName,
        "sightseeing_costing": citiesWithActivities[cityName],
        "day_total_cost": dayTotalCost.toFixed(2),
        "day_total_cost_with_tax": dayTotalCostWithTax.toFixed(2)};
    });
    
    // If no cities with activities, still create an entry for the day
    if (cityEntries.length === 0 && day.citiesWithActivities.length > 0) {
      return {
        "day": `Day ${String(day.number).padStart(2, '0')}`,
        "calendar_date": day.date || "Not Selected",
        "city": day.citiesWithActivities[0]?.city || "Unknown",
        "sightseeing_costing": [],
        "day_total_cost": dayTotalCost.toFixed(2),
        "day_total_cost_with_tax": dayTotalCostWithTax.toFixed(2)};
    }
    
    return cityEntries.length > 0 ? cityEntries : [];
  });
  
  // Flatten the array since we might have multiple cities per day
  const flattenedTicketPriceData = ticketPriceData.flat();
  
  // Add taxes array to each itinerary_cost entry
  flattenedTicketPriceData.forEach(entry => {
    entry.taxes = taxData; // Include the same taxes array that's in the main JSON
  });

  // --- Ensure all location_visit_adults_n_children_count are in sync with bookingDetails ---
  flattenedTicketPriceData.forEach(entry => {
    if (Array.isArray(entry.sightseeing_costing)) {
      entry.sightseeing_costing.forEach(costing => {
        if (costing.location_visit_adults_n_children_count) {
          costing.location_visit_adults_n_children_count.no_of_adults = numAdults || "0";
          costing.location_visit_adults_n_children_count.no_of_children = numChildren || "0";
        }
      });
    }
  });

  return removeNullValues({
    customerName: selectedCustomerName,
    customer_id: selectedCustomerId,
    bookingDetails: {
      numAdults,
      numChildren,
      roomCount,
      roomCategory,
      bookingType,
      bookingStartDate,
      bookingEndDate,
      specificBookingDate,
      vehicleDetails: selectedVehicleDetails ? { ...selectedVehicleDetails } : null, 
      marketType,
    },
    taxes: taxData,
    rates: ratesArg || rates,
    days: formattedDays,
    itinerary_cost: itineraryCost,
    accommodation: accommodationDetails
  });
};


const formatEditItineraryData = (ratesArg) => {
  // --- Step 1: Build lookup for previous manually updated sightseeing entries ---
  const previousManualUpdates = {};
  if (editData && Array.isArray(editData.itinerary_cost)) {
    editData.itinerary_cost.forEach(dayCost => {
      const day = dayCost.day;
      const city = dayCost.city;
      if (Array.isArray(dayCost.sightseeing_costing)) {
        dayCost.sightseeing_costing.forEach(costing => {
          if (costing.manually_updated) {
            const key = `${day}|${city}|${costing.location_name}`;
            previousManualUpdates[key] = costing;
          }
        });
      }
    });
  }

  // --- Step 2: Continue with the usual formatting, but preserve manual updates ---
  const formattedDays = days.map((day, index) => {
    // Check if this is the last day - if so, don't include selected hotels
    const isLastDay = index === days.length - 1;
    
    // Get selected hotels for this day (empty for last day)
    const daySelectedHotels = isLastDay ? [] : Object.values(selectedHotelsMap)
  .filter(hotel => hotel.dayId === day.id && selectedRatings.includes(hotel.rating))
  .map(hotel => ({
    hotel_id: hotel.hotel_id,
    hotel_name: hotel.name,
    rating: hotel.rating,
    city: hotel.city === "Uncategorized" ? day.citiesWithActivities[0]?.city || hotel.city : hotel.city,
    selected_room_type: hotel.selectedRoomType || "",  // Ensure this is included
    selected_type: hotel.selectedType || ""  // Ensure this is included
  }));

      
    return {
      day_number: String(day.number),
      calander_date: day.date,
      type_of_day: day.type,
      selected_hotels: daySelectedHotels.length > 0 ? daySelectedHotels : undefined,
      city: day.citiesWithActivities.map((city) => ({
        city_id: city.city_id || "C001",
        city_name: city.city,
        city_description: city.city_description || "",
        city_image: Array.isArray(city.city_image)
          ? city.city_image
          : [city.city_image || ""],
      })),
      activity: day.citiesWithActivities.flatMap((city) =>
        city.activities.map((activity) => {
          // Always create tickets object if ticketCategory and ticketPrice exist,
          // even if they are empty strings (this preserves the structure)
          let tickets = null;
          if (activity.ticketCategory && activity.ticketPrice) {
            // Handle new ticket price structure with separate prices for adults and children
            if (typeof activity.ticketPrice === 'object' && (activity.ticketPrice.adults || activity.ticketPrice.children)) {
              tickets = {
                [activity.ticketCategory]: activity.ticketPrice
              };
            } else {
              // Fallback to the old format if ticketPrice is a string
              tickets = {
                [activity.ticketCategory]: activity.ticketPrice
              };
            }
          }

          return {
            activity_type: activity.activity_type,
            city: city.city,
            inclusion: activity.inclusion === true,
            arrangement: activity.arrangement || "Own Arrangement",
            hotel_name: activity.hotel_name || null,
            hotel_id: activity.hotel_id || null,
            mealPlan: activity.mealPlan || null,
            roomType: activity.roomType || null,
            restaurant_name: activity.restaurant_name || null,
            meal: activity.meal || null,
            location_name: activity.location_name || null,
            location_id: activity.location_id || null,
            location_img_path: activity.location_img_path || [],
            description: activity.description || null,
            type: activity.type || "Optional",
            tickets: tickets, // Include tickets object whether null or with values
            tickets_price: activity.tickets_price || false,
            ticketAvailability: activity.ticketAvailability || false,
            taxAvailable: activity.taxAvailable || false,
taxDetails: activity.taxDetails || [], // Include specific tax details from the attractions

            // Also include the individual ticket fields to ensure they're preserved in state
            ticketCategory: activity.ticketCategory || null,
            ticketPrice: activity.ticketPrice || null,
            taxedPrices: activity.taxedPrices || null // Include the calculated tax prices
          };
        })
      ),
    };
  });

  let itineraryCost;

  // Always calculate itinerary_cost from the latest days/activities
  // This ensures costing modules and EntranceFeePopup are always up-to-date
  const ticketPriceData = days.map(day => {
    // Group activities by city for this day
    const citiesWithActivities = {};
    
    // First, collect all activities for each city in this day
    day.citiesWithActivities.forEach(city => {
      // Filter only sightseeing activities that have ticket information
      const sightseeingActivities = city.activities
        .filter(activity =>
          activity.activity_type === "sightseeing" &&
          (activity.ticketCategory || activity.tickets_price || activity.ticketAvailability)
        )
        .map(activity => {
          // --- Preservation of manual updates ---
          const key = `Day ${String(day.number).padStart(2, '0')}|${city.city}|${activity.location_name}`;
          const prevManual = previousManualUpdates[key];
          if (prevManual) {
            return {
              ...prevManual,
              location_visit_adults_n_children_count: {
                no_of_adults: numAdults || prevManual.location_visit_adults_n_children_count?.no_of_adults || "0",
                no_of_children: numChildren || prevManual.location_visit_adults_n_children_count?.no_of_children || "0"
              },
              manually_updated: true
            };
          }
          // Calculate total price based on adults and children
          let adultPrice = 0;
          let childrenPrice = 0;
        
          
          // Handle new ticket price structure with separate prices for adults and children
          if (activity.ticketPrice && typeof activity.ticketPrice === 'object') {
            // Extract adult and children prices from the object
            adultPrice = parseFloat(activity.ticketPrice.adults?.replace('$', '')) || 0;
            childrenPrice = parseFloat(activity.ticketPrice.children?.replace('$', '')) || 0;
          } else {
            // Fallback to the old format if ticketPrice is a string
            adultPrice = parseFloat(String(activity.ticketPrice).replace('$', '')) || 0;
            childrenPrice = 0; // No children price in old format
          }
          
          const numAdultsValue = parseInt(numAdults) || 0;
          const numChildrenValue = parseInt(numChildren) || 0;
          const totalPrice = (adultPrice * numAdultsValue) + (childrenPrice * numChildrenValue);
          
          console.log(`Calculating total price for ${activity.location_name}: ${adultPrice} × ${numAdultsValue} adults + ${childrenPrice} × ${numChildrenValue} children = ${totalPrice}`);
          
          // Calculate price with tax using taxedPrices directly
          let totalPriceWithTax = totalPrice;
          let taxDetails = [];
          
          if (activity.taxedPrices && typeof activity.taxedPrices === 'object') {
            // Get the ticket category
            const category = activity.ticketCategory || Object.keys(activity.taxedPrices)[0];
            
            if (category && activity.taxedPrices[category]) {
              // Extract adults_with_tax and children_with_tax values
              const adultsTaxedPrice = parseFloat(activity.taxedPrices[category].adults_with_tax || 0);
              const childrenTaxedPrice = parseFloat(activity.taxedPrices[category].children_with_tax || 0);
              
              // Calculate total with tax based on adults and children count
              const numAdultsValue = parseInt(numAdults) || 0;
              const numChildrenValue = parseInt(numChildren) || 0;
              totalPriceWithTax = (adultsTaxedPrice * numAdultsValue) + (childrenTaxedPrice * numChildrenValue);
              
              // Build tax details
              const adultTaxAmount = adultsTaxedPrice - adultPrice;
              const childrenTaxAmount = childrenTaxedPrice - childrenPrice;
              
              if (activity.taxDetails && activity.taxDetails.length > 0) {
                activity.taxDetails.forEach(tax => {
                  taxDetails.push({
                    tax_name: tax.tax_name || 'Tax',
                    tax_percentage: tax.tax_percentage || 0,
                    tax_amount: Math.round((adultTaxAmount * numAdultsValue) + (childrenTaxAmount * numChildrenValue))
                  });
                });
              }
              
              console.log(`Using taxed prices for ${activity.location_name}: adults ${adultPrice} -> ${adultsTaxedPrice}, children ${childrenPrice} -> ${childrenTaxedPrice}, total: ${totalPriceWithTax}`);
            } else {
              // Fallback to old format if category not found
              totalPriceWithTax = activity.taxedPrices.totalWithTax || totalPrice;
              taxDetails = activity.taxedPrices.appliedTaxes || [];
              console.log(`Using old taxed price format for ${activity.location_name}: ${totalPrice} + tax = ${totalPriceWithTax}`);
            }
          } else if (activity.taxAvailable && activity.taxDetails && activity.taxDetails.length > 0) {
            // Calculate tax manually if taxedPrices is not available but taxDetails is
            let taxAmount = 0;
            activity.taxDetails.forEach(tax => {
              const taxValue = (totalPrice * (tax.tax_percentage / 100));
              taxAmount += taxValue;
              taxDetails.push({
                tax_name: tax.tax_name,
                tax_percentage: tax.tax_percentage,
                tax_amount: Math.round(taxValue)
              });
            });
            totalPriceWithTax = totalPrice + taxAmount;
            console.log(`Calculated tax for ${activity.location_name}: ${totalPrice} + ${taxAmount} = ${totalPriceWithTax}`);
          }
          
          return {
            "location_name": activity.location_name || "",
            "location_total_ticket_price": totalPrice > 0 ? parseFloat(totalPrice).toFixed(2) : "0.00",
            "with_tax_location_total_ticket_price": totalPriceWithTax > 0 ? parseFloat(totalPriceWithTax).toFixed(2) : "0.00",
            "location_visit_adults_n_children_count": {
              "no_of_adults": numAdults || "0",
              "no_of_children": numChildren || "0"
            },
            "ticket_prices": {
              "adult_ticket_price": {
                "currency": "$",
                "value": adultPrice > 0 ? parseFloat(adultPrice).toFixed(2) : "0.00"
              },
              "children_ticket_price": {
                "currency": childrenPrice > 0 ? "$" : "Not Selected",
                "value": childrenPrice > 0 ? parseFloat(childrenPrice).toFixed(2) : "0.00"
              }
            },
            "taxed_prices": {
              "adult_with_tax": activity.taxedPrices && activity.ticketCategory && activity.taxedPrices[activity.ticketCategory] ?
                parseFloat(activity.taxedPrices[activity.ticketCategory].adults_with_tax || 0).toFixed(2) : "0.00",
              "children_with_tax": activity.taxedPrices && activity.ticketCategory && activity.taxedPrices[activity.ticketCategory] ?
                parseFloat(activity.taxedPrices[activity.ticketCategory].children_with_tax || 0).toFixed(2) : "0.00"
            },
            "tickets_country_category": activity.ticketCategory || "Not Selected",
            "taxAvailable": activity.taxAvailable || false,
            "taxDetails": taxDetails.map(tax => ({ tax_name: tax.tax_name })) // Only include tax_name for each tax
          };
        });
      
      if (sightseeingActivities.length > 0) {
        if (!citiesWithActivities[city.city]) {
          citiesWithActivities[city.city] = [];
        }
        citiesWithActivities[city.city].push(...sightseeingActivities);
      }
    });
    
    // Calculate day total cost (both with and without tax)
    let dayTotalCost = 0;
    let dayTotalCostWithTax = 0;
    Object.values(citiesWithActivities).forEach(activities => {
      activities.forEach(activity => {
        // Parse string values to numbers before addition
        const activityCost = typeof activity.location_total_ticket_price === 'string' ?
          parseFloat(activity.location_total_ticket_price) :
          parseFloat(activity.location_total_ticket_price || 0);
          
        const activityCostWithTax = typeof activity.with_tax_location_total_ticket_price === 'string' ?
          parseFloat(activity.with_tax_location_total_ticket_price) :
          parseFloat(activity.with_tax_location_total_ticket_price || 0);
        
        // Add using numeric addition
        dayTotalCost += isNaN(activityCost) ? 0 : activityCost;
        dayTotalCostWithTax += isNaN(activityCostWithTax) ? 0 : activityCostWithTax;
        
        // Debug info
        console.log(`Adding ${activity.location_name}: ${activityCost} (base) / ${activityCostWithTax} (with tax)`);
      });
    });
    
    // Create entry for each city in this day
    const cityEntries = Object.keys(citiesWithActivities).map(cityName => {
      return {
        "day": `Day ${String(day.number).padStart(2, '0')}`,
        "calendar_date": day.date || "Not Selected",
        "city": cityName,
        "sightseeing_costing": citiesWithActivities[cityName],
        "day_total_cost": dayTotalCost.toFixed(2),
        "day_total_cost_with_tax": dayTotalCostWithTax.toFixed(2)};
    });
    
    // If no cities with activities, still create an entry for the day
    if (cityEntries.length === 0 && day.citiesWithActivities.length > 0) {
      return {
        "day": `Day ${String(day.number).padStart(2, '0')}`,
        "calendar_date": day.date || "Not Selected",
        "city": day.citiesWithActivities[0]?.city || "Unknown",
        "sightseeing_costing": [],
        "day_total_cost": dayTotalCost.toFixed(2),
        "day_total_cost_with_tax": dayTotalCostWithTax.toFixed(2)};
    }
    
    return cityEntries.length > 0 ? cityEntries : [];
  });
  
  // Flatten the array since we might have multiple cities per day
  const flattenedTicketPriceData = ticketPriceData.flat();
  
  // Add taxes array to each itinerary_cost entry
  flattenedTicketPriceData.forEach(entry => {
    entry.taxes = taxData; // Include the same taxes array that's in the main JSON
  });

  // --- Preserve manually updated transport_costing, accommodation, and miscellaneous_expenses arrays ---
  if (editData && Array.isArray(editData.itinerary_cost)) {
    // Build lookups for day|city to original arrays if manually_updated
    const transportCostingPreserveMap = {};
    const accommodationPreserveMap = {};
    const miscellaneousExpensesPreserveMap = {};
    const otherExpensesPreserveMap = {};
    // --- Build lookups for preserving manually updated arrays ---
    const guideAccommodationPreserveMap = {};
    editData.itinerary_cost.forEach(origEntry => {
      const key = `${origEntry.day}|${origEntry.city}`;
      if (Array.isArray(origEntry.transport_costing) && origEntry.transport_costing.some(tc => tc.manually_updated)) {
        transportCostingPreserveMap[key] = origEntry.transport_costing;
      }
      if (origEntry.accommodation && origEntry.accommodation.manually_updated) {
        accommodationPreserveMap[key] = origEntry.accommodation;
      }
      if (Array.isArray(origEntry.miscellaneous_expenses) && origEntry.miscellaneous_expenses.some(exp => exp.manually_updated)) {
        miscellaneousExpensesPreserveMap[key] = origEntry.miscellaneous_expenses;
      }
      // Preserve Other_Expenses if any entry is manually_updated
      if (Array.isArray(origEntry.Other_Expenses) && origEntry.Other_Expenses.some(exp => exp.manually_updated)) {
        otherExpensesPreserveMap[key] = origEntry.Other_Expenses;
      }
      // Preserve guide_accommodation if any entry is manually_updated
      if (Array.isArray(origEntry.guide_accommodation) && origEntry.guide_accommodation.some(exp => exp.manually_updated)) {
        guideAccommodationPreserveMap[key] = origEntry.guide_accommodation.filter(exp => exp.manually_updated);
      }
    });
    // For each entry in the new flattenedTicketPriceData, if key matches, preserve arrays
    flattenedTicketPriceData.forEach(entry => {
      const key = `${entry.day}|${entry.city}`;
      if (transportCostingPreserveMap[key]) {
        entry.transport_costing = transportCostingPreserveMap[key];
      }
      if (accommodationPreserveMap[key]) {
        entry.accommodation = accommodationPreserveMap[key];
      }
      if (miscellaneousExpensesPreserveMap[key]) {
        entry.miscellaneous_expenses = miscellaneousExpensesPreserveMap[key].map(exp => ({
          ...exp,
          manually_updated: true
        }));
      }
      if (otherExpensesPreserveMap[key]) {
        entry.Other_Expenses = otherExpensesPreserveMap[key].map(exp => ({
          ...exp,
          manually_updated: true
        }));
      }
      // --- Preserve manually updated guide_accommodation ---
      if (guideAccommodationPreserveMap[key]) {
        // If the new entry has guide_accommodation, merge in any preserved manual ones not present
        const newArr = Array.isArray(entry.guide_accommodation) ? entry.guide_accommodation : [];
        const preservedArr = guideAccommodationPreserveMap[key];
        // Merge: keep all manual ones, and add any new ones that are not manually_updated
        const mergedArr = [
          ...preservedArr,
          ...newArr.filter(exp => !exp.manually_updated || !preservedArr.some(p => JSON.stringify(p) === JSON.stringify(exp)))
        ];
        entry.guide_accommodation = mergedArr;
      }
    });
  }

  itineraryCost = flattenedTicketPriceData;


  // --- Ensure all location_visit_adults_n_children_count are in sync with bookingDetails ---
  if (Array.isArray(itineraryCost)) {
    itineraryCost.forEach(entry => {
      if (Array.isArray(entry.sightseeing_costing)) {
        entry.sightseeing_costing.forEach(costing => {
          if (costing.location_visit_adults_n_children_count) {
            costing.location_visit_adults_n_children_count.no_of_adults = numAdults || "0";
            costing.location_visit_adults_n_children_count.no_of_children = numChildren || "0";
          }
        });
      }
    });
  }

   return removeNullValues({
    itinerary_id: editData?.itinerary_id || "",
    updates: {
      customerName: selectedCustomerName,
      customer_id: selectedCustomerId,
      bookingDetails: {
        numAdults,
        numChildren,
        roomCount,
        roomCategory,
        bookingType,
        bookingStartDate,
        bookingEndDate,
        specificBookingDate,
        vehicleDetails: selectedVehicleDetails ? { ...selectedVehicleDetails } : null,
        marketType,
      },
      taxes: taxData,
      rates: ratesArg || rates,
      days: formattedDays,
      itinerary_cost: itineraryCost,
    },
  });
};




/* const postItineraryData = async () => {
  setIsSubmitting(true); // Start loading
  const data = editData?.itinerary_id
    ? formatEditItineraryData()
    : formatItineraryData();

  console.log("Formatted Itinerary Data:", JSON.stringify(data, null, 2));

  if (!token) {
    alert("Authorization token is missing.");
    setIsSubmitting(false); // End loading
    return;
  }

  const endpoint = editData?.itinerary_id
    ? "https://us-central1-evoq-travel-craft.cloudfunctions.net/update_itinerary_data"
    : "https://us-central1-evoq-travel-craft.cloudfunctions.net/add_itinerary_data";

  try {
    const response = await makeAuthenticatedRequest(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: Bearer ${token},
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const errorDetails = await response.json();
      throw new Error(
        Failed to save itinerary: ${response.status} - ${
          errorDetails.error || "Unknown error"
        }
      );
    }

    const result = await response.json();
    const savedData = result.data;

    if (editData?.itinerary_id) {
      alert("Itinerary successfully updated!");
      navigate("/user", {
        state: {
          updatedItineraryId: editData.itinerary_id, // Pass the updated itinerary ID
          successMessage: "Itinerary successfully updated!",
          token,
        },
      });
    } else {
      alert("New itinerary successfully created!");
      setEditData(savedData); // Update editData with the saved itinerary data
    }

    setIsSubmitted(true); // Set the submission flag to true
  } catch (error) {
    console.error("Error in saving itinerary:", error);
    alert(Error: ${error.message});
  } finally {
    setIsSubmitting(false); // End loading
  }
}; */


const getCrudOperation = (method, url) => {
  if (method === "POST") {
    if (url.includes("add_itinerary_data")) return "CREATE";
    if (url.includes("update_itinerary_data")) return "UPDATE";
    return "CREATE (External)";
  }
  return "UNKNOWN";
};

const postItineraryData = async () => {
  if (!selectedCustomerId) {
    alert("Please select a customer.");
    return;
  }
  setIsSubmitting(true);

  // Always fetch latest rates before saving
  const latestRates = await fetchRates();

  // Ensure that all activities, including the last one, are captured
  setDays((prevDays) => {
    const updatedDays = prevDays.map((day) => ({
      ...day,
      citiesWithActivities: day.citiesWithActivities.map((city) => ({
        ...city,
        activities: [...city.activities], // Ensure activities array is up to date
      })),
    }));
    return updatedDays;
  });

  // Use the latest rates in the payload
  const data = editData?.itinerary_id
    ? formatEditItineraryData(latestRates)
    : formatItineraryData(latestRates);
  data.price_change = true;

  console.log("Final Request Body JSON:", JSON.stringify(data, null, 2));

  if (!token) {
    alert("Authorization token is missing.");
    setIsSubmitting(false);
    return;
  }

  const endpoint = editData?.itinerary_id
    ? "https://us-central1-evoq-travel-craft.cloudfunctions.net/update_itinerary_data"
    : "https://us-central1-evoq-travel-craft.cloudfunctions.net/add_itinerary_data";

  try {
    const response = await makeAuthenticatedRequest(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const errorDetails = await response.json();
      throw new Error(`Failed to save itinerary: ${response.status} - ${errorDetails.error || "Unknown error"}`);
    }

    const result = await response.json();
    if (editData?.itinerary_id) {
       await showSuccess("Itinerary successfully updated!");
    } else {
    await showSuccess("New itinerary successfully created!");
      setEditData(result.data);
    }

    setIsSubmitted(true);
  } catch (error) {
    alert(`Error: ${error.message}`);
  } finally {
    setIsSubmitting(false);
  }
};


const [documentLink, setDocumentLink] = useState(null); // To store the document link
const [selectedTheme, setSelectedTheme] = useState("forest_trail"); // Default theme
const [isThemeDropdownOpen, setIsThemeDropdownOpen] = useState(false); // For theme dropdown


// Handle click outside to close theme dropdown

useEffect(() => {
  const handleEscKey = (event) => {
    if (event.key === 'Escape' && isThemeDropdownOpen) {
      setIsThemeDropdownOpen(false);
    }
  };
  
  // Add event listener
  document.addEventListener("keydown", handleEscKey);
  
  // Cleanup
  return () => {
    document.removeEventListener("keydown", handleEscKey);
  };
}, [isThemeDropdownOpen]);

const handleGenerateItinerary = async (themeOverride) => {
  if (!selectedCustomerId) {
    alert("Please select a customer.");
    return;
  }
  setIsGenerating(true);
  setShowLoadingOverlay(true); // Show LoadingScreen

  try {
    const isEditingMode = editData?.itinerary_id != null;
    const saveEndpoint = isEditingMode
      ? "https://us-central1-evoq-travel-craft.cloudfunctions.net/update_itinerary_data"
      : "https://us-central1-evoq-travel-craft.cloudfunctions.net/add_itinerary_data";

    // Always fetch latest rates before generating
    const fetchedRates = await fetchRates();
    const itineraryData = isEditingMode
      ? formatEditItineraryData(fetchedRates)
      : formatItineraryData(fetchedRates);
      
    // Preserve price_change flag if it exists in the costing popups
    if (isEditingMode && editData?.price_change === true) {
      itineraryData.updates.itinerary_cost = editData.itinerary_cost;
    }

    // Add price_change flag to the request payload
    if (isEditingMode) {
      itineraryData.price_change = true;
    }
    
    // Log the request data and endpoint
    console.log("Request Data:", JSON.stringify(itineraryData, null, 2));
    console.log("Request Endpoint:", saveEndpoint);

    if (!token) {
      alert("Authorization token is missing.");
      setShowLoadingOverlay(false); // Hide LoadingScreen
      return;
    }

    // Request to save itinerary
    const saveResponse = await makeAuthenticatedRequest(saveEndpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(itineraryData),
    });

    // Log the response from the save request
    const saveResponseData = await saveResponse.json();
    console.log("Save Response:", JSON.stringify(saveResponseData, null, 2));

    if (!saveResponse.ok) {
      throw new Error(`Failed to save itinerary: ${saveResponse.status} - ${saveResponseData.error || "Unknown error"}`);
    }

    const savedData = saveResponseData.data;
    const itineraryId = savedData?.itinerary_id;

    if (!itineraryId) {
      throw new Error("Itinerary ID not found in response.");
    }

    // Step 2: Post itinerary ID to external API
    const externalResponse = await makeAuthenticatedRequest(
      "https://summarymodel-flash-14140141147.us-central1.run.app",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ itinerary_id: itineraryId }),
      }
    );

    // Log the external API response
    const externalResponseData = await externalResponse.json();
    console.log("External API Response:", JSON.stringify(externalResponseData, null, 2));

    if (externalResponse.status !== 200) {
      throw new Error(`Failed to post to external API. Status: ${externalResponse.status}`);
    }

    // Step 3: Generate document with selected theme
    const themeToUse = themeOverride || selectedTheme;
    const postBody = { 
      itinerary_id: itineraryId,
      theme_name: themeToUse 
    };
    console.log("POST body for generate-document-v2:", JSON.stringify(postBody, null, 2));
    const generateResponse = await makeAuthenticatedRequest(
      "https://generate-document-v2-14140141147.us-central1.run.app",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(postBody),
      }
    );

    // Log the document generation response
    const generateResponseData = await generateResponse.json();
    console.log("Generate Document Response:", JSON.stringify(generateResponseData, null, 2));

    if (!generateResponse.ok) {
      throw new Error(`Failed to generate document: ${generateResponse.status} - ${generateResponseData.error || "Unknown error"}`);
    }

    const documentResponse = generateResponseData;
    setDocumentLink(documentResponse.document_link);
    setEditData(prevData => prevData); 
    setIsEditing(true);
    await showSuccess("Itinerary saved and now in edit mode! You can download it.");
  } catch (error) {
    await showError(`Error: ${error.message}`);
  } finally {
    setIsGenerating(false);
    setShowLoadingOverlay(false); // Hide LoadingScreen
  }
};


const handleDayClick = (dayIndex) => {
  const targetDay = document.getElementById(`day-${dayIndex}`);
  if (targetDay) {
    targetDay.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }
};


const handleDragEnd = (result) => {
  const { source, destination } = result;

  if (!destination) return; // If dropped outside, do nothing

  // Reorder the days array
  const reorderedDays = Array.from(days);
  const [removed] = reorderedDays.splice(source.index, 1);
  reorderedDays.splice(destination.index, 0, removed);

  // Update day numbers based on the new order
  const updatedDays = reorderedDays.map((day, index) => ({
    ...day,
    number: index + 1, // Reassign the day number (1-based index)
  }));

  // Update the state
  setDays(updatedDays);
};

const handleDeleteDay = async (dayId) => {
  const confirmDelete = await showConfirm("Are you sure you want to delete this day?");
  if (confirmDelete) {
    const updatedDays = days
      .filter((day) => day.id !== dayId)
      .map((day, index) => ({
        ...day,
        number: index + 1,
      }));
    setDays(updatedDays);
  }
};

const fetchRoomCategories = async () => {
  if (!token) {
    console.error("Authorization token is missing.");
    return;
  }

  try {
    const response = await makeAuthenticatedRequest(
      "https://us-central1-evoq-travel-craft.cloudfunctions.net/get_hotel_room_type_data",
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Error fetching room categories: ${response.statusText}`);
    }

    const data = await response.json();
    setRoomCategories(data.data || []);
  } catch (err) {
    console.error("Failed to fetch room categories:", err.message);
  }
};


useEffect(() => {
  fetchRoomCategories();
}, [token]);

const fetchVehicleTypes = async () => { 
  if (!token) {
    console.error("Authorization token is missing.");
    return;
  }

  setIsLoadingVehicles(true);

  try {
    const response = await makeAuthenticatedRequest(
      "https://us-central1-evoq-travel-craft.cloudfunctions.net/get_vehicle_data",
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Error fetching vehicle types: ${response.statusText}`);
    }

    const data = await response.json();
    
    // Print full API response to console
    console.log("Vehicle Data API Response:", JSON.stringify(data, null, 2));

    // Set the state with vehicle data
    setVehicleTypes(data.data || []);
  } catch (error) {
    console.error("Failed to fetch vehicle types:", error.message);
  } finally {
    setIsLoadingVehicles(false);
  }
};

const handleVehicleChange = (selectedValue) => { 
  // Instead of splitting, find the vehicle directly by the full make+model string
  const selectedVehicle = vehicleTypes.find(
    (vehicle) => `${vehicle.make} ${vehicle.model}` === selectedValue
  );

  if (selectedVehicle) {
    const vehicleType = `${selectedVehicle.make} ${selectedVehicle.model}`; // Create vehicleType

    const vehicleDetails = {
      category: selectedVehicle.category,
      luggage_space: selectedVehicle.luggage_space,
      make: selectedVehicle.make,
      maximum_seating_capacity: selectedVehicle.maximum_seating_capacity,
      model: selectedVehicle.model,
      seats: selectedVehicle.seats,
      vehicle_img: selectedVehicle.vehicle_img,
      vehicle_type_id: selectedVehicle.vehicle_type_id,
      vehicleType, // Include the concatenated make + model
       additional_fee_per_km: selectedVehicle.additional_fee_per_km,
        bata_price: selectedVehicle.bata_price,
        fee_per_100km: selectedVehicle.fee_per_100km,
    };

    // Print selected vehicle details before setting state
    console.log("Selected Vehicle Details:", JSON.stringify(vehicleDetails, null, 2));
    console.log("Generated vehicleType:", vehicleType); // Debugging output

    setSelectedVehicleDetails(vehicleDetails);
    setVehicleType(vehicleType); // Update vehicleType in state
  } else {
    console.warn("No vehicle details found for selected type:", selectedValue);
    setSelectedVehicleDetails(null);
    setVehicleType(""); // Reset vehicleType if not found
  }
};







useEffect(() => {
  fetchVehicleTypes();
}, [token]);




useEffect(() => {
  if (editData) {
    console.log("Switched to Edit Itinerary mode. Edit Itinerary Details:", editData);

    // Loop through the days and their associated cities
    editData.days.forEach((day, index) => {
      // Check if selected_hotels exists before accessing it
      if (day.selected_hotels && Array.isArray(day.selected_hotels)) {
        day.selected_hotels.forEach(hotel => {
          // Print selected room type and selected type for each hotel
          console.log(`Hotel: ${hotel.hotel_name} Details:`);
          console.log(`Selected Room Type: ${hotel.selected_room_type}`);
          console.log(`Selected Type: ${hotel.selected_type}`);
          
          // Print available room types and types
          console.log("Available Room Types:", hotel.room_types);
          console.log("Available Types:", hotel.types);
        });
      } else {
        console.warn(`No selected_hotels for Day ${index + 1}`);
      }
    });
  }
}, [editData]);


const [cityHotels, setCityHotels] = useState({});
const [availableRatings, setAvailableRatings] = useState([]);

// Add state declarations for hotel selections BEFORE they're used in functions below
const [selectedRatings, setSelectedRatings] = useState([]);
const [selectedHotelsMap, setSelectedHotelsMap] = useState({});
const [previouslySelectedRatings, setPreviouslySelectedRatings] = useState(new Set());

// Modify the fetchHotelsForCity function and wrap it in useCallback
const fetchHotelsForCity = useCallback(async (city) => {
  if (!token || !city) return Promise.resolve(); // Return resolved promise if no token or city
  
  try {
    const response = await makeAuthenticatedRequest(
      "https://us-central1-evoq-travel-craft.cloudfunctions.net/get_hotel_location_data",
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ city_name: [city] }),
      }
    );
    const data = await response.json();
    const hotels = data.data.hotels || [];

    // Process hotels to include room types and types
    const processedHotels = hotels.map(hotel => ({
      ...hotel,
      room_types: Array.isArray(hotel.room_types) ? hotel.room_types : [], // Ensure room_types is a valid array
      types: typeof hotel.types === 'object' ? hotel.types : {}, // Ensure types is a valid object
      main_room_type: hotel.main_room_type || "" 
    }));
    
    // Reduce logging to prevent console spam
    if (processedHotels.length > 0 && false) { // Disable verbose logging
      processedHotels.forEach(hotel => {
        console.log(`Hotel ${hotel.name} - Room Types: ${JSON.stringify(hotel.room_types)}, Meal Types: ${JSON.stringify(Object.keys(hotel.types || {}))}`);
      });
    }

    // Reduce logging to prevent console spam
    console.log(`Fetched ${processedHotels.length} hotels for ${city}`);
    // Disable detailed logging
    if (processedHotels.length > 0 && false) {
      console.log(`Sample hotel data for ${processedHotels[0].name}:`);
      console.log(`Room types:`, processedHotels[0].room_types);
      console.log(`Types:`, processedHotels[0].types);
    }

    // Group hotels by rating
    const grouped = processedHotels.reduce((acc, hotel) => {
      const rawRating = parseFloat(hotel.ratings || 0);
      const rating = Math.round(rawRating * 2) / 2;
      if (!acc[rating]) acc[rating] = [];
      acc[rating].push(hotel);
      return acc;
    }, {});

    // Get unique ratings and sort them
    const ratings = [...new Set(processedHotels.map(hotel => {
      const rawRating = parseFloat(hotel.ratings || 0);
      return Math.round(rawRating * 2) / 2;
    }))].sort((a, b) => b - a);
    
    setAvailableRatings(ratings);
    setCityHotels(prev => ({
      ...prev,
      [city]: grouped
    }));
    
    // Automatically show ratings for existing selections
    const existingRatings = Object.values(selectedHotelsMap)
      .filter(hotel => hotel.city === city)
      .map(hotel => hotel.rating);
    
    if (existingRatings.length > 0) {
      setSelectedRatings(prev => {
        const newRatings = [...new Set([...prev, ...existingRatings])];
        return newRatings.sort((a, b) => b - a);
      });
    }
    
    return Promise.resolve(grouped); // Return the grouped hotels
  } catch (err) {
    console.error(`Error fetching hotels for ${city}:`, err);
    return Promise.reject(err); // Return rejected promise on error
  }
}, [token]); // Remove selectedHotelsMap from dependencies to avoid circular references

const fetchAllCityHotels = useCallback(async (cities) => {
  const uniqueCities = [...new Set(cities.map(city => city.city))];
  
  const promises = [];
  for (const city of uniqueCities) {
    if (!cityHotels[city]) {
      promises.push(fetchHotelsForCity(city));
    }
  }
  
  // Wait for all hotel fetch operations to complete
  await Promise.all(promises);
  return true; // Return a resolved value for .then() chaining
}, [cityHotels, fetchHotelsForCity, token]); // Added token to dependencies


const [isLoadingHotels, setIsLoadingHotels] = useState(false);
const [isLoadingHotelDetails, setIsLoadingHotelDetails] = useState(false);
const [hotelsAlreadyLoaded, setHotelsAlreadyLoaded] = useState(false); // Track if hotels were already loaded
const [selectedRating, setSelectedRating] = useState(null);
const [showRatingSelector, setShowRatingSelector] = useState(false);
const [loadingProgress, setLoadingProgress] = useState(0);
const [loadingSource, setLoadingSource] = useState(''); // 'cache' or 'network'



// Effect to ensure loading indicator is properly reset after a short delay




// Effect to ensure loading indicator is properly reset after a short delay
useEffect(() => {
  if (isLoadingHotelDetails) {
    // Set a timeout to reset the loading state after 3 seconds just in case
    const timer = setTimeout(() => {
      setIsLoadingHotelDetails(false);
    }, 3000); // 3 seconds should be plenty of time for any hotel details to load
    
    // Clear the timeout if the component unmounts or the loading state changes
    return () => clearTimeout(timer);
  }
}, [isLoadingHotelDetails]);

// Function to force refresh hotel data by clearing cache
const forceRefreshHotels = useCallback(() => {
  console.log("Force refreshing hotel data");
  
  // Step 1: Clear all hotel-related data structures
  // Clear the sessionStorage cache
  sessionStorage.removeItem('allHotelsData');
  
  // Step 2: Reset all hotel-related state
  // Clear in-memory hotel collections
  setCityHotels({});
  setAllHotelsCollection([]);
  setSelectedHotelsMap(prevMap => {
    // Only keep selected hotel IDs and basic info, clear extra data
    const newMap = {};
    Object.entries(prevMap).forEach(([key, hotel]) => {
      if (hotel) {
        newMap[key] = {
          ...hotel,
          // Reset these fields to ensure they're freshly loaded
          room_types: [],
          types: {},
          selectedRoomType: hotel.selectedRoomType || '',
          selectedType: hotel.selectedType || ''
        };
      }
    });
    return newMap;
  });
  
  // Step 3: Reset loading flags to trigger a complete refresh
  setIsLoadingHotels(true);
  setLoadingProgress(0);
  setHotelsAlreadyLoaded(false);
  
  // Also clear any status flags that might prevent a fresh load
  setLoadingSource('network'); // Mark this as a network load, not a cache load
}, []);

// Add a manual refresh button to the UI
// This is simpler and more reliable than automatic checking with the current backend
useEffect(() => {
  // Add refresh capability when popup opens
  if (isDetailsPopupOpen) {
    // Add a maximum age for the cache (15 minutes)
    const MAX_CACHE_AGE = 10 * 60 * 1000; // 15 minutes in milliseconds
    
    // Check cache age
    const cachedData = sessionStorage.getItem('allHotelsData');
    if (cachedData) {
      try {
        const parsedCache = JSON.parse(cachedData);
        const cacheTimestamp = parsedCache.timestamp;
        const cacheAge = Date.now() - cacheTimestamp;
        
        // If cache is older than MAX_CACHE_AGE, refresh it
        if (cacheAge > MAX_CACHE_AGE) {
          console.log(`Cache is ${Math.round(cacheAge/1000/60)} minutes old, refreshing automatically`);
          forceRefreshHotels();
        }
      } catch (err) {
        console.error("Error parsing cached data", err);
        // If there's an error with the cache, force a refresh
        forceRefreshHotels();
      }
    }
  }
}, [isDetailsPopupOpen, forceRefreshHotels]);

// Function to fetch all hotels from the API with caching
const fetchAllHotels = useCallback(async () => {
  if (!token) {
    setError("Authorization token is missing.");
    return [];
  }

  setIsLoadingHotels(true);
  setLoadingProgress(0);
  
  try {
    // Check if we have cached hotel data
    const cachedData = sessionStorage.getItem('allHotelsData');
    setLoadingProgress(10); // Update progress
    
    if (cachedData) {
      try {
        const parsedData = JSON.parse(cachedData);
        const cacheTimestamp = parsedData.timestamp;
        
        // Check if cache is less than 30 minutes old
        if (Date.now() - cacheTimestamp < 30 * 60 * 1000) {
          console.log("Using cached hotel data from sessionStorage");
          setLoadingSource('cache');
          setLoadingProgress(100); // Cache hit - complete progress immediately
          setTimeout(() => {
            setIsLoadingHotels(false);
            setLoadingProgress(0);
          }, 500); // Give UI time to show 100% before hiding
          return parsedData.hotels;
        } else {
          console.log("Cache expired, fetching fresh hotel data");
          setLoadingSource('network');
        }
      } catch (err) {
        console.error("Error parsing cached hotel data:", err);
        setLoadingSource('network');
        // Continue to fetch fresh data if there's an error with the cache
      }
    } else {
      console.log("No cached hotel data found, fetching from API");
      setLoadingSource('network');
    }
    
    setLoadingProgress(20); // Preparing to fetch
    
    // If we reach here, we need to fetch fresh data
    const response = await makeAuthenticatedRequest(
      "https://us-central1-evoq-travel-craft.cloudfunctions.net/get_hotel_data",
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Error fetching hotels: ${response.statusText}`);
    }

    setLoadingProgress(50); // Data received, processing
    const data = await response.json();
    setLoadingProgress(70); // JSON parsed
    
    // Process hotels to ensure they have required properties
    const processedHotels = (data.data || []).map(hotel => ({
      ...hotel,
      room_types: hotel.room_types || [], 
      types: hotel.types || {}, 
      main_room_type: hotel.main_room_type || "",
      city: hotel.city || hotel.location || "Uncategorized"
    }));
    
    setLoadingProgress(80); // Hotels processed
    
    // Cache the processed data with timestamp
    try {
      sessionStorage.setItem('allHotelsData', JSON.stringify({
        timestamp: Date.now(),
        hotels: processedHotels
      }));
      setLoadingProgress(90); // Data cached
      console.log(`Cached ${processedHotels.length} hotels to sessionStorage`);
    } catch (err) {
      console.error("Error caching hotel data:", err);
      // Continue even if caching fails
    }
    
    // Log only once when data is successfully processed
    console.log(`Processed ${processedHotels.length} hotels`);
    setLoadingProgress(100); // Complete
    
    // Reset loading state after a short delay to show completion
    setTimeout(() => {
      setIsLoadingHotels(false);
      setLoadingProgress(0);
    }, 500);
    
    return processedHotels;
  } catch (err) {
    console.error("Failed to fetch all hotels:", err.message);
    return [];
  } finally {
    setIsLoadingHotels(false);
  }
}, [token]); // Only re-create if token changes

// Add this effect to fetch hotels when popup opens
useEffect(() => {
  let isMounted = true; // Flag to track if component is mounted
  let isLoading = false; // Additional flag to prevent duplicate API calls
  let loadingTimer = null; // Timer to ensure loading state is reset
  
  // Only fetch hotels if popup is open AND we haven't already loaded hotels OR if isDetailsPopupOpen just changed to true
  if (isDetailsPopupOpen && !isLoading && !hotelsAlreadyLoaded) {
    console.log("Opening hotel details popup");
    setIsLoadingHotels(true); // Start loading indicator
    isLoading = true; // Set our local loading flag
    
    // Safety timeout - ensure loading state is reset after 15 seconds no matter what
    loadingTimer = setTimeout(() => {
      if (isMounted) {
        console.log("Forcing loading state reset after timeout");
        setIsLoadingHotels(false);
      }
    }, 15000); // 15 second safety timeout
    
    const allCities = days.flatMap(day => day.citiesWithActivities);

    const loadAllHotels = async () => {
      try {
        // First fetch all hotels for all cities
        await fetchAllCityHotels(allCities);
        
        // Only proceed if component is still mounted
        if (!isMounted) {
          console.log("Component unmounted during city hotels fetch");
          return;
        }
        
        // Then fetch all hotels using the new endpoint
        const allHotels = await fetchAllHotels();
        
        // Only update state if component is still mounted
        if (!isMounted) {
          console.log("Component unmounted during all hotels fetch");
          return;
        }
        
        // Store the fetched hotels in state
        setAllHotelsCollection(allHotels);
        console.log("Successfully stored hotel collection with", allHotels.length, "hotels");
        
        // Process and organize all hotels by city and rating
        const allHotelsMap = {};
        
        // Create a special "All Hotels" category
        if (!allHotelsMap["All Hotels"]) {
          allHotelsMap["All Hotels"] = {};
        }
        
        // Process all hotels, including those with missing city data
        allHotels.forEach(hotel => {
          // Prioritize city field, then location field
          const city = hotel.city || hotel.location || "Uncategorized";
          
          const rawRating = parseFloat(hotel.ratings || 0);
          const rating = Math.round(rawRating * 2) / 2;
          
          // Add to city-specific category
          if (!allHotelsMap[city]) {
            allHotelsMap[city] = {};
          }
          
          if (!allHotelsMap[city][rating]) {
            allHotelsMap[city][rating] = [];
          }

          // Add to "All Hotels" category as well
          if (!allHotelsMap["All Hotels"][rating]) {
            allHotelsMap["All Hotels"][rating] = [];
          }
          
          // Ensure room_types and types are properly included
          const processedHotel = {
            ...hotel,
            room_types: Array.isArray(hotel.room_types) ? hotel.room_types : [],
            types: typeof hotel.types === 'object' ? hotel.types : {},
            main_room_type: hotel.main_room_type || ""
          };
          
          // Add to city-specific list
          allHotelsMap[city][rating].push(processedHotel);
          
          // Also add to "All Hotels" list
          allHotelsMap["All Hotels"][rating].push(processedHotel);
        });
        
        if (!isMounted) {
          console.log("Component unmounted during hotel processing");
          return;
        }
        
        // Merge with existing cityHotels - but limit updates to prevent re-render loops
        const mergedCityHotels = { ...cityHotels };
        
        // Add all hotels to each city's hotel list
        Object.keys(allHotelsMap).forEach(city => {
          if (!mergedCityHotels[city]) {
            mergedCityHotels[city] = {};
          }
          
          Object.keys(allHotelsMap[city]).forEach(rating => {
            if (!mergedCityHotels[city][rating]) {
              mergedCityHotels[city][rating] = [];
            }
            
            // Add hotels that don't already exist
            allHotelsMap[city][rating].forEach(hotel => {
              const exists = mergedCityHotels[city][rating].some(
                h => h.hotel_id === hotel.hotel_id
              );
              
              if (!exists) {
                mergedCityHotels[city][rating].push(hotel);
              }
            });
          });
        });
        
        if (!isMounted) {
          console.log("Component unmounted during hotel merging");
          return;
        }
        
        // Use a batched update to prevent cascading state updates
        setCityHotels(mergedCityHotels);
        console.log("Successfully updated cityHotels");
        
        // After hotels are fetched, process each city
        allCities.forEach((cityObj) => {
          const city = cityObj.city;
          const ratings = Object.keys(mergedCityHotels[city] || {});

          ratings.forEach((rating) => {
            const day = days.find(d =>
              d.citiesWithActivities.some(c => c.city === city)
            );
            const key = `${day?.id}-${city}-${rating}`;

            // Find mealPlan from activities (for pre-filling selectedType)
            const mealPlanFromActivity = cityObj.activities?.find(
              (activity) => activity.activity_type === "checkin"
            )?.mealPlan || '';

            // Find roomType from activities (for pre-filling selectedRoomType)
            const roomTypeFromActivity = cityObj.activities?.find(
              (activity) => activity.activity_type === "checkin"
            )?.roomType || '';

            // Find hotel name from activities
            const hotelNameFromActivity = cityObj.activities?.find(
              (activity) => activity.activity_type === "checkin"
            )?.hotel_name;

            // If there's a hotel in the activity, try to find it in cityHotels
            if (hotelNameFromActivity) {
              const matchingHotel = mergedCityHotels[city]?.[rating]?.find(
                hotel => hotel.name === hotelNameFromActivity
              );

              if (matchingHotel) {
                // Check if the meal plan is available in the hotel's types
                const isExistingMealPlanAvailable = mealPlanFromActivity && 
                  matchingHotel.types && 
                  matchingHotel.types[mealPlanFromActivity];

                if (isMounted) {
                  setSelectedHotelsMap(prev => ({
                    ...prev,
                    [key]: {
                      hotel_id: matchingHotel.hotel_id,
                      name: matchingHotel.name,
                      rating: parseFloat(rating),
                      city,
                      dayId: day?.id,
                      dayNumber: day?.number,
                      room_types: matchingHotel.room_types || [],
                      types: matchingHotel.types || {},
                      main_room_type: matchingHotel.main_room_type || '',
                      selectedRoomType: roomTypeFromActivity || matchingHotel.main_room_type || '',
                      selectedType: isExistingMealPlanAvailable ? mealPlanFromActivity : ''
                    }
                  }));
                }
                return; // Skip the rest of this iteration
              }
            }

            // If no matching hotel found or no hotel in activity, use first hotel as fallback
            if (!selectedHotelsMap[key]) {
              const firstHotel = mergedCityHotels[city]?.[rating]?.[0];
              if (firstHotel && isMounted) {
                // Check if the meal plan is available in the hotel's types
                const isExistingMealPlanAvailable = mealPlanFromActivity && 
                  firstHotel.types && 
                  firstHotel.types[mealPlanFromActivity];

                setSelectedHotelsMap(prev => ({
                  ...prev,
                  [key]: {
                    hotel_id: firstHotel.hotel_id,
                    name: firstHotel.name,
                    rating: parseFloat(rating),
                    city,
                    dayId: day?.id,
                    dayNumber: day?.number,
                    room_types: firstHotel.room_types || [],
                    types: firstHotel.types || {},
                    main_room_type: firstHotel.main_room_type || '',
                    selectedRoomType: roomTypeFromActivity || firstHotel.main_room_type || '',
                    selectedType: isExistingMealPlanAvailable ? mealPlanFromActivity : ''
                  }
                }));
              }
            } else if (!selectedHotelsMap[key].selectedType && mealPlanFromActivity && isMounted) {
              // If hotel already selected but type is missing, just fill type
              setSelectedHotelsMap(prev => ({
                ...prev,
                [key]: {
                  ...prev[key],
                  selectedType: mealPlanFromActivity
                }
              }));
            }
          });
        });

        // Always turn off loading indicator when processing is complete
        console.log("Hotel processing complete, turning off loading state");
        if (isMounted) {
          setIsLoadingHotels(false);
          setHotelsAlreadyLoaded(true); // Mark hotels as loaded so we don't reload them
          
          // Clear the safety timeout since we're done
          if (loadingTimer) {
            clearTimeout(loadingTimer);
            loadingTimer = null;
          }
        }
      } catch (error) {
        console.error("Error loading hotels:", error);
        // Always turn off loading on error
        if (isMounted) {
          setIsLoadingHotels(false);
          
          // Clear the safety timeout
          if (loadingTimer) {
            clearTimeout(loadingTimer);
            loadingTimer = null;
          }
        }
      } finally {
        // Reset the loading flag no matter what
        isLoading = false;
        
        // Add one final safety check to ensure loading is turned off
        if (isMounted) {
          // Use a small timeout to ensure this runs after all other state updates
          setTimeout(() => {
            if (isMounted) {
              setIsLoadingHotels(false);
            }
          }, 500);
        }
      }
    };
    
    // Run our async function
    loadAllHotels();
    
    // Cleanup function
    return () => {
      isMounted = false;
      
      // Clear the safety timeout if component unmounts
      if (loadingTimer) {
        clearTimeout(loadingTimer);
        loadingTimer = null;
      }
      
      // Ensure loading is turned off when component unmounts
      setIsLoadingHotels(false);
    };
  }
  
  // If popup is closed but loading is still true, reset it
  if (!isDetailsPopupOpen) {
    if (isLoadingHotels) {
      setIsLoadingHotels(false);
    }
    // Reset the hotelsAlreadyLoaded flag when the popup is closed
    if (hotelsAlreadyLoaded) {
      setHotelsAlreadyLoaded(false);
    }
  }
}, [isDetailsPopupOpen, days, fetchAllCityHotels, fetchAllHotels, isLoadingHotels, hotelsAlreadyLoaded]);

// Effect to handle hotel selection when cities change
useEffect(() => {
  if (availableCities.length > 0 && selectedCity) {
    // Get all hotels for the selected city
    const hotelsForCity = availableCities.find(city => city.name === selectedCity)?.hotels || [];
    if (hotelsForCity.length > 0) {
      // Pre-select the first hotel
      setSelectedHotel(hotelsForCity[0].id);
    }
  }
}, [availableCities, selectedCity]);

  const bookingFieldsStyle = `
.no-spinner {
  -moz-appearance: textfield;
}

.no-spinner::-webkit-outer-spin-button,
.no-spinner::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
`;

// Add the style to document head (add this near the existing animation styles)
if (typeof document !== 'undefined') {
  const bookingStyleEl = document.createElement('style');
  bookingStyleEl.type = 'text/css';
  bookingStyleEl.appendChild(document.createTextNode(bookingFieldsStyle));
  document.head.appendChild(bookingStyleEl);
}

// Add keyboard navigation handler
const handleKeyDown = (e, currentField, setCurrentField, allFields) => {
  if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
    e.preventDefault();
    const currentIndex = allFields.indexOf(currentField);
    let nextIndex;
    
    if (e.key === 'ArrowUp') {
      nextIndex = currentIndex > 0 ? currentIndex - 1 : allFields.length - 1;
    } else {
      nextIndex = currentIndex < allFields.length - 1 ? currentIndex + 1 : 0;
    }
    
    const nextField = allFields[nextIndex];
    const nextElement = document.getElementById(nextField);
    if (nextElement) {
      nextElement.focus();
      setCurrentField(nextField);
    }
  }
};

// Add state for tracking current field
const [currentField, setCurrentField] = useState('');

// Define field order for navigation
const bookingFields = ['numAdults', 'numChildren', 'roomCount'];
  return (
    <div className="">
      <h1 className="text-2xl font-bold mb-4">
        {editData ? "Edit Itinerary" : "Create Itinerary"}
      </h1>

      {error && <p className="text-red-500 mb-4">{error}</p>}
      {isLoadingCities && (
        <p className="text-blue-500 mb-4">Loading cities...</p>
      )}

<div className="mb-4 flex items-center gap-20">
  <div>
    <label className="mr-2">Select Agent:</label>
    <select
      value={selectedCustomerId}
      onChange={handleCustomerSelect}
      className="p-2 border rounded"
    >
      {/* <option value="">-- Select a Customer --</option> */}
      {customers.map((customer) => (
        <option key={customer.customer_id} value={customer.customer_id}>
          {customer.name}
        </option>
      ))}
    </select>
  </div>
  {editData?.itinerary_id && (
  <div className="mb-4 text-sm text-gray-700 dark:text-gray-300">
     <strong>ID: </strong>{editData.id}
  </div>
)}
  </div>

  {/* Booking Details Form */}
<div className="mb-6 p-4 border rounded shadow-md bg-gray-50 max-w-4xl">
  <h2 className="text-lg font-bold mb-4">Booking Details</h2>

  {/* Passengers Section */}

  <div className="grid grid-cols-2 gap-4 mb-4">
  <div>
    <label className="block text-sm font-medium text-gray-700">Number of Adults:</label>
    <input
      id="numAdults"
      type="number"
      value={numAdults}
      onChange={(e) => setNumAdults(e.target.value)}
      onKeyDown={(e) => handleKeyDown(e, 'numAdults', setCurrentField, bookingFields)}
      onFocus={() => setCurrentField('numAdults')}
      className="w-full p-2 border rounded no-spinner"
      min="1"
    />
  </div>
  <div>
    <label className="block text-sm font-medium text-gray-700">Number of Children:</label>
    <input
      id="numChildren"
      type="number"
      value={numChildren}
      onChange={(e) => setNumChildren(e.target.value)}
      onKeyDown={(e) => handleKeyDown(e, 'numChildren', setCurrentField, bookingFields)}
      onFocus={() => setCurrentField('numChildren')}
      className="w-full p-2 border rounded no-spinner"
      min="0"
    />
  </div>
</div>


<div className="grid grid-cols-2 gap-4 mb-4">
  <div>
    <label className="block text-sm font-medium text-gray-700">Required Rooms:</label>
    <input
      id="roomCount"
      type="number"
      value={roomCount}
      onChange={(e) => setRoomCount(e.target.value)}
      onKeyDown={(e) => handleKeyDown(e, 'roomCount', setCurrentField, bookingFields)}
      onFocus={() => setCurrentField('roomCount')}
      className="w-full p-2 border rounded no-spinner"
      min="1"
    />
  </div>
    <div className="grid grid-cols-2 gap-4 mb-4">
  <div>
    <label className="block text-sm font-medium text-gray-700">Room Category:</label>
    
    {/* Custom Dropdown with Search */}
    <div className="relative">
    <input
  type="text"
  placeholder="Search Room Category..."
  value={roomCategory || searchQuery}
  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
  onChange={(e) => {
    setSearchQuery(e.target.value);
    setRoomCategory(e.target.value); // update visible value as you type
  }}
  className="p-2 border rounded mb-2"
  style={{ width: "420px" }} 
/>


      
      {/* Dropdown list */}
      {isDropdownOpen && (
        <div className="absolute z-10 w-full mt-1 bg-white border rounded shadow-lg max-h-60 overflow-y-auto">
          <ul className="p-2">
            {roomCategories
              .filter((category) =>
                category.room_type.toLowerCase().includes(searchQuery.toLowerCase()) // Filter based on search
              )
              .map((category, index) => (
                <li
                  key={index}
                  onClick={() => {
                    setRoomCategory(category.room_type);
                    setSelectedRoomCategory(category.room_type);
                    setIsDropdownOpen(false);
                    setSearchQuery(""); // Reset search after selection
                  }}
                  
                  className="p-2 cursor-pointer hover:bg-gray-200"
                >
                  {category.room_type}
                </li>
              ))}
          </ul>
        </div>
      )}
    </div>
  </div>
</div>

  </div>

 {/* Booking Period/Date Section */}
<div className="mb-4">
  <label className="block text-sm font-medium text-gray-700 mb-2">Booking Type:</label>
  <div className="flex gap-4 mb-3">
    <label className="flex items-center">
      <input
        type="radio"
        name="bookingType"
        value="period"
        checked={bookingType === "period"}
        onChange={(e) => setBookingType(e.target.value)}
        className="mr-2"
      />
      Booking Period (Start & End Date)
    </label>
    <label className="flex items-center">
      <input
        type="radio"
        name="bookingType"
        value="date"
        checked={bookingType === "date"}
        onChange={(e) => setBookingType(e.target.value)}
        className="mr-2"
      />
      Specific Booking Date
    </label>
  </div>
  
  {bookingType === "period" && (
    <div className="grid grid-cols-2 gap-4">
      <div>
        <label className="block text-sm font-medium text-gray-700">Start Date:</label>
        <input
          type="date"
          value={bookingStartDate}
          onChange={(e) => setBookingStartDate(e.target.value)}
          className="w-full p-2 border rounded"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700">End Date:</label>
        <input
          type="date"
          value={bookingEndDate}
          onChange={(e) => setBookingEndDate(e.target.value)}
          className="w-full p-2 border rounded"
          min={bookingStartDate} // Ensure end date can't be before start date
        />
      </div>
    </div>
  )}
  
  {bookingType === "date" && (
    <div>
      <label className="block text-sm font-medium text-gray-700">Booking Date:</label>
      <input
        type="date"
        value={specificBookingDate}
        onChange={(e) => setSpecificBookingDate(e.target.value)}
        className="w-full p-2 border rounded"
      />
    </div>
  )}
</div>
   
 

  
{/* Vehicle Type Selection */}
<div className="mb-4">
  <label className="block text-sm font-medium text-gray-700">Vehicle Type:</label>
  
  {/* Custom Dropdown with Search for Vehicle Type */}
  <div className="relative">
  <input
  type="text"
  placeholder="Search Vehicle..."
  value={vehicleType || vehicleSearchQuery}
  onClick={() => setIsVehicleDropdownOpen(!isVehicleDropdownOpen)}
  onChange={(e) => {
    setVehicleSearchQuery(e.target.value);
    setVehicleType(e.target.value); // Keep input updated while typing
  }}
  className="w-full p-2 border rounded mb-2"
  style={{ width: "860px" }}
/>

    
    {/* Dropdown list */}
    {isVehicleDropdownOpen && (
      <div className="absolute z-10 w-full mt-1 bg-white border rounded shadow-lg max-h-60 overflow-y-auto">
        <ul className="p-2">
          {vehicleTypes
            .filter((vehicle) =>
              `${vehicle.make} ${vehicle.model}`
                .toLowerCase()
                .includes(vehicleSearchQuery.toLowerCase()) // Filter vehicles based on search
            )
            .map((vehicle, index) => (
              <li
                key={index}
                onClick={() => {
                  handleVehicleChange(`${vehicle.make} ${vehicle.model}`);
                  setIsVehicleDropdownOpen(false);
                  setVehicleSearchQuery(""); // Clear search after selection
                }}
                
                className="p-2 cursor-pointer hover:bg-gray-200"
              >
                {vehicle.make} {vehicle.model}
              </li>
            ))}
        </ul>
      </div>
    )}
  </div>
</div>

{/* Market Type Selection */}
<div className="mb-4">
  <label className="block text-sm font-medium text-gray-700">Market Type:</label>
  
  {/* Custom Dropdown with Search for Market Type */}
  <div className="relative">
    <input
      type="text"
      placeholder="Search Market Type..."
      value={marketType || marketTypeSearchQuery}
      onClick={() => setIsMarketTypeDropdownOpen(!isMarketTypeDropdownOpen)}
      onChange={(e) => {
        setMarketTypeSearchQuery(e.target.value);
        setMarketType(e.target.value);
      }}
      className="w-full p-2 border rounded mb-2"
      style={{ width: "420px" }}
    />
    
    {/* Dropdown list */}
    {isMarketTypeDropdownOpen && (
      <div className="absolute z-10 w-full mt-1 bg-white border rounded shadow-lg max-h-60 overflow-y-auto">
        <ul className="p-2">
          {marketTypes
            .filter((market) =>
              market.toLowerCase().includes(marketTypeSearchQuery.toLowerCase())
            )
            .map((market, index) => (
              <li
                key={index}
                onClick={() => {
                  setMarketType(market);
                  setIsMarketTypeDropdownOpen(false);
                  setMarketTypeSearchQuery("");
                }}
                className="p-2 cursor-pointer hover:bg-gray-200"
              >
                {market}
              </li>
            ))}
        </ul>
      </div>
    )}
  </div>
</div>

  {/* Save Button
  <button
    onClick={() => {
      if (!numAdults || !roomCount || !roomCategory || !vehicleType) {
        alert("Please fill in all required fields.");
        return;
      }
      alert("Booking details saved! You can now add days.");
    }}
    className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
  >
    Save Booking Details
  </button> */}
</div>


  
  <button
    onClick={openAddDayPopup}
    className="px-4 py-2 bg-blue-500 text-white rounded rounded-3xl"
  >
    Add Day
  </button>


<DragDropContext onDragEnd={handleDragEnd}>
  <Droppable droppableId="days">
    {(provided) => (
      <div
        {...provided.droppableProps}
        ref={provided.innerRef}
        className="space-y-4 mt-4"
      >
        {days.map((day, index) => (
         <Draggable key={day.id} draggableId={String(day.id)} index={index}>
         {(provided) => (
           <div
             id={`day-${index}`} // Add this line for unique identification
             ref={provided.innerRef}
             {...provided.draggableProps}
             {...provided.dragHandleProps}
           >
             <DayCard
  key={day.id}
  day={day}
  onUpdateDay={(id, cities, details) => {
    onUpdateDay(id, cities, details); // Ensure function is used
  }}
  onDeleteDay={handleDeleteDay}
  selectedRoomCategory={selectedRoomCategory}
/>

           </div>
         )}
       </Draggable>
       
        ))}
        {provided.placeholder}
      </div>
    )}
  </Droppable>
</DragDropContext>

               {/*  Floating Add Day Button
                <div>
      <button
        onClick={openAddDayPopup}
        className="fixed bottom-1/4 right-6 bg-blue-600 text-white rounded-full p-4 shadow-lg hover:bg-blue-700 mr-72 mb-8"
        title="Add a new day"
      >
        +
      </button>
      </div> */}
                {/* Right Sidebar */}
           {/* Right Sidebar */}
<div className="w-72 bg-blue-100 p-4 fixed top-0 right-0 h-full shadow-lg overflow-y-auto border-l border-gray-300">
    <h2 className="text-xl font-bold mb-6 text-center text-blue-700 border-b pb-2">Days Overview</h2>
    <ul className="space-y-4">
  {days.map((day, index) => {
    let icon;
    switch (day.type) {
      case "Arrival Day":
        icon = <i className="fas fa-plane-arrival text-green-500"></i>;
        break;
      case "Departure Day":
        icon = <i className="fas fa-plane-departure text-red-500"></i>;
        break;
      case "Travel Day":
        icon = <i className="fas fa-bus text-blue-500"></i>;
        break;
      case "Rest Day":
        icon = <i className="fas fa-bed text-yellow-500"></i>;
        break;
      default:
        icon = <i className="fas fa-calendar text-gray-500"></i>;
    }

    return (
      <li key={day.id} className="flex items-center gap-3">
        <span className="text-lg">{icon}</span>
        <button
          onClick={() => handleDayClick(index)} // Scroll to relevant day
          className="flex-1 text-left px-4 py-3 rounded-lg bg-blue-500 text-white font-semibold shadow-md hover:bg-blue-600 hover:shadow-lg transition"
        >
          Day {day.number}: {day.type}
        </button>
      </li>
    );
  })}
</ul>

</div>

      {isPopupOpen && (
      <AddDayPopup
      onClose={closeAddDayPopup}
      onAddDay={handleAddDay}
      editData={editData}
    />
    
      )}

<div className="fixed bottom-10 right-80 flex flex-col items-center justify-center gap-6">
  {/* Show Day Details Button */}
  <button
    onClick={() => setIsDetailsPopupOpen(true)}
    className="bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 text-white font-semibold text-lg rounded-full w-12 h-12 flex items-center justify-center shadow-xl transition-transform transform hover:scale-110 hover:shadow-2xl focus:outline-none focus:ring-2 focus:ring-indigo-300"
    title="Show Day Details"
  >
    <i className="fas fa-hotel text-xl"></i>
  </button>

  {/* Add Day Button */}
  <button
    onClick={openAddDayPopup}
    className="bg-gradient-to-r from-green-400 to-blue-500 text-white font-semibold text-lg rounded-full w-12 h-12 flex items-center justify-center shadow-xl transition-transform transform hover:scale-110 hover:shadow-2xl focus:outline-none focus:ring-2 focus:ring-green-300"
    title="Add a new day"
  >
    <span className="text-2xl">+</span>
  </button>

  {/* Back Button */}
  <button
    onClick={() => navigate("/user", { state: { token } })}
    className="bg-gradient-to-r from-gray-600 to-gray-800 text-white font-semibold text-lg rounded-full w-12 h-12 flex items-center justify-center shadow-xl transition-transform transform hover:scale-110 hover:shadow-2xl focus:outline-none focus:ring-2 focus:ring-gray-300"
    title="Go Back"
  >
    <span className="text-2xl">←</span>
  </button>

{/*   Costing Button */}
 <button
    onClick={() => navigate("/costing", { state: { token, itineraryId: editData?.itinerary_id } })}
    className="bg-gradient-to-r from-purple-500 to-indigo-600 text-white font-semibold text-lg rounded-full w-12 h-12 flex items-center justify-center shadow-xl transition-transform transform hover:scale-110 hover:shadow-2xl focus:outline-none focus:ring-2 focus:ring-purple-300"
    title="Go to Costing"
  >
    <span className="text-2xl">$</span>
  </button>
  
</div>


{/* Popup for displaying day details */}
{isDetailsPopupOpen && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
    <div className="relative bg-white rounded-lg p-6 shadow-lg w-[85vw] max-h-[90vh] overflow-auto">
      <button 
        onClick={() => setIsDetailsPopupOpen(false)} 
        className="absolute top-2 right-2 text-gray-600 hover:text-black text-xl"
      >
        ✖
      </button>

      {/* Loading Progress Bar */}
      {isLoadingHotels && loadingProgress > 0 && (
        <div className="mb-4">
          <div className="flex justify-between items-center mb-1">
            <span className="text-sm font-medium text-blue-700">
              {loadingSource === 'cache' ? 'Loading from cache...' : 'Loading hotels from server...'}
            </span>
            <span className="text-sm font-medium text-blue-700">{loadingProgress}%</span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2.5">
            <div 
              className="bg-blue-600 h-2.5 rounded-full transition-all duration-300 ease-in-out" 
              style={{ width: `${loadingProgress}%` }}
            ></div>
          </div>
        </div>
      )}

      {/* Hotel Controls */}
      <div className="mb-4 flex items-center justify-between">
        <div className="flex items-center">
          <button
            onClick={() => setShowRatingSelector(true)}
            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 mr-3"
            disabled={isLoadingHotels}
          >
            {isLoadingHotels ? (
              <span className="flex items-center">
                <i className="fas fa-spinner fa-spin mr-2"></i>
                Loading Hotels...
              </span>
            ) : (
              "Load Other Hotels"
            )}
          </button>
          
          {/* Rating selector - Moved next to Load Other Hotels button */}
          {showRatingSelector && (
            <div className="flex items-center gap-2">
              <span className="font-medium">Select Rating:</span>
              <select
                value=""
                onChange={(e) => {
                  const newRating = Number(e.target.value);
                  if (newRating && !selectedRatings.includes(newRating)) {
                    setSelectedRatings([...selectedRatings, newRating].sort((a, b) => b - a));
                  }
                }}
                className="p-2 border rounded"
              >
                <option value="">Select Rating</option>
                {[...new Set(Object.values(cityHotels)
                  .flatMap(cityData => Object.keys(cityData || {}))
                  .map(Number)
                  .sort((a, b) => b - a))]
                  .filter(rating => !selectedRatings.includes(rating))
                  .map(rating => (
                    <option key={rating} value={rating}>{rating.toFixed(1)} Stars</option>
                  ))}
              </select>
            </div>
          )}
        </div>
        
        {/* Manual Refresh Button - Still on the right side */}
        <div>
          <button
            onClick={forceRefreshHotels}
            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center"
            disabled={isLoadingHotels}
            title="Refresh hotel data from server"
          >
            <i className="fas fa-sync-alt "></i>
           
          </button>
        </div>
      </div>

      <table className="w-full table-auto">
        <thead>
          <tr>
            <th className="border px-4 py-2">Day</th>
            <th className="border px-4 py-2">City</th>
            <th className="border px-4 py-2">Selected Hotels</th>
            {selectedRatings.map(rating => (
              <th key={rating} className="border px-4 py-2 relative">
                <div className="flex items-center justify-between px-2">
                  <span>Rating {rating.toFixed(1)} Hotels</span>
                  <button
                    onClick={() => setSelectedRatings(selectedRatings.filter(r => r !== rating))}
                    className="ml-2 text-gray-500 hover:text-red-500 font-bold"
                    title="Remove column"
                  >
                    ×
                  </button>
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {days.slice(0, -1).map((day) => (
            day.citiesWithActivities.map((city, cityIndex) => (
              <tr key={`${day.id}-${cityIndex}`}>
                <td className="border px-4 py-2">{day.number}</td>
                <td className="border px-4 py-2">{city.city}</td>
                <td className="border px-4 py-2">
                {city.activities
  .filter(activity => activity.activity_type === "checkin" && activity.hotel_name)
  .map((activity, idx) => (
    <div key={idx} className="text-sm bg-blue-100 px-2 py-1 rounded mb-1">
      <div><strong>{activity.hotel_name}</strong></div>
      {activity.mealPlan && (
        <div className="text-xs text-gray-700 italic">
          Meal Plan: {activity.mealPlan}
        </div>
      )}

{activity.roomType && (
        <div className="text-xs text-gray-700 italic">
          Room Type: {activity.roomType}
        </div>
      )}
    </div>
  ))}

                </td>
               
                {selectedRatings.map(rating => (
                  <td key={rating} className="border px-4 py-2">
                    <div className="relative space-y-2">
                      {cityHotels[city.city]?.[rating]?.length > 0 ? (
                        <>
                         
                         <select 
  className="w-full p-2 border rounded text-sm"
  value={
    selectedHotelsMap[`${day.id}-${city.city}-${rating}`]?.hotel_id ||
    (cityHotels[city.city]?.[rating]?.[0]?.hotel_id || "")
  }
  onChange={(e) => {
    const hotelId = e.target.value;
  
    if (hotelId) {
      // Show loading indicator while fetching hotel details
      setIsLoadingHotelDetails(true);
      
      // Search for the hotel in all cities and ratings
      let selectedHotel = null;
      
      // First try to find in the current city and rating
      if (cityHotels[city.city]?.[rating]) {
        selectedHotel = cityHotels[city.city][rating].find(h => h.hotel_id === hotelId);
      }
      
      // If not found, search in all cities and ratings
      if (!selectedHotel) {
        Object.keys(cityHotels).forEach(cityName => {
          Object.keys(cityHotels[cityName] || {}).forEach(ratingValue => {
            const foundHotel = cityHotels[cityName][ratingValue].find(h => h.hotel_id === hotelId);
            if (foundHotel) {
              selectedHotel = foundHotel;
            }
          });
        });
      }
  
      if (selectedHotel) {
        // Determine the appropriate city value - IMPORTANT CHANGE
        let hotelCity = selectedHotel.city || 
                      selectedHotel.location || 
                      selectedHotel.city_name || 
                      city.city;
                
        // Never use "Uncategorized" as a city
        if (hotelCity === "Uncategorized") {
          hotelCity = city.city; // Use the day's city instead
        }
  
        // Get the existing meal plan from activities if available
        const existingMealPlan = city.activities.find(
          act => act.activity_type === "checkin"
        )?.mealPlan || '';
  
        // Ensure room_types is properly loaded
        const roomTypes = Array.isArray(selectedHotel.room_types) ? selectedHotel.room_types : [];
        
        // Ensure types (meal plans) is properly loaded
        const mealTypes = typeof selectedHotel.types === 'object' ? selectedHotel.types : {};
        
        // Check if the meal plan is available in the hotel's types
        const isExistingMealPlanAvailable = existingMealPlan && 
          mealTypes && 
          mealTypes[existingMealPlan];
  
        setSelectedHotelsMap(prev => ({
          ...prev,
          [`${day.id}-${city.city}-${rating}`]: {
            hotel_id: selectedHotel.hotel_id,
            name: selectedHotel.name,
            rating: rating,
            city: hotelCity, // Now using the correct city
            dayId: day.id,
            dayNumber: day.number,
            room_types: roomTypes,
            types: mealTypes,
            main_room_type: selectedHotel.main_room_type || '',
            selectedRoomType: selectedHotel.main_room_type || '',
            selectedType: isExistingMealPlanAvailable ? existingMealPlan : ''
          }
        }));
        
        // Hide loading indicator after hotel details are successfully loaded
        setIsLoadingHotelDetails(false);
      }
    } else {
      // If no hotel selected, remove it from map
      setSelectedHotelsMap(prev => {
        const newMap = { ...prev };
        delete newMap[`${day.id}-${city.city}-${rating}`];
        return newMap;
      });
    }
  }}
>
  <option value="">Select Hotel</option>
  {/* First show hotels from the current city and rating (prioritized) */}
  {cityHotels[city.city]?.[rating]?.length > 0 && (
    <optgroup label={`${city.city} - ${rating} Star Hotels`}>
      {cityHotels[city.city][rating].map((hotel) => (
        <option key={hotel.hotel_id} value={hotel.hotel_id}>
          {hotel.name}
        </option>
      ))}
    </optgroup>
  )}
  
  {/* Show ALL hotels from ALL cities, categorized by both city and rating */}
  {Object.keys(cityHotels).filter(cityName => 
    // Only include real cities, exclude the current city and special categories
    cityName !== city.city && cityName !== "All Hotels" && cityName !== "Uncategorized"
  ).map(cityName => {
    // For each city, show hotels grouped by rating
    return Object.keys(cityHotels[cityName] || {}).map(ratingValue => {
      const hotelsWithRating = cityHotels[cityName][ratingValue] || [];
      
      return hotelsWithRating.length > 0 && (
        <optgroup key={`${cityName}-${ratingValue}`} label={`${cityName} - ${ratingValue} Star Hotels`}>
          {hotelsWithRating.map((hotel) => (
            <option key={hotel.hotel_id} value={hotel.hotel_id}>
              {hotel.name}
            </option>
          ))}
        </optgroup>
      );
    });
  })}
  
  {/* Show hotels by their city_name with rating */}
  {cityHotels["Uncategorized"] && 
    Object.keys(cityHotels["Uncategorized"] || {}).map(ratingValue => {
      const hotelsWithRating = cityHotels["Uncategorized"][ratingValue] || [];
      
      // Group hotels by city_name
      const hotelsByCity = {};
      hotelsWithRating.forEach(hotel => {
        const cityName = hotel.city_name || "Other";
        if (!hotelsByCity[cityName]) {
          hotelsByCity[cityName] = [];
        }
        hotelsByCity[cityName].push(hotel);
      });
      
      // Create optgroups for each city
      return Object.entries(hotelsByCity).map(([cityName, cityHotels]) => (
        <optgroup key={`${cityName}-${ratingValue}`} label={`${cityName} - ${ratingValue} Star Hotels`}>
          {cityHotels.map((hotel) => (
            <option key={hotel.hotel_id} value={hotel.hotel_id}>
              {hotel.name}
            </option>
          ))}
        </optgroup>
      ));
    })
  }
</select>

                          {selectedHotelsMap[`${day.id}-${city.city}-${rating}`] && (
                            <div className="space-y-2 mt-2">
                              {/* Room Types Dropdown */}
                        
                              {selectedHotelsMap[`${day.id}-${city.city}-${rating}`] && (
                            <select
                              className="w-full p-2 border rounded text-sm bg-gray-50"
                              value={selectedHotelsMap[`${day.id}-${city.city}-${rating}`]?.selectedRoomType || ''}
                              onChange={(e) => {
                                const roomType = e.target.value;
                                setSelectedHotelsMap(prev => ({
                                  ...prev,
                                  [`${day.id}-${city.city}-${rating}`]: {
                                    ...prev[`${day.id}-${city.city}-${rating}`],
                                    selectedRoomType: roomType
                                  }
                                }));
                              }}
                            >
                              <option value="">Select Room Type</option>
                              {/* Add main_room_type as the first option if it exists */}
                              {selectedHotelsMap[`${day.id}-${city.city}-${rating}`]?.main_room_type && (
                                <option 
                                  key="main_room_type" 
                                  value={selectedHotelsMap[`${day.id}-${city.city}-${rating}`].main_room_type}
                                >
                                  {selectedHotelsMap[`${day.id}-${city.city}-${rating}`].main_room_type} 
                                </option>
                              )}
                              {/* Get room types from the selected hotel in cityHotels */}
                              {(() => {
                                const hotelId = selectedHotelsMap[`${day.id}-${city.city}-${rating}`]?.hotel_id;
                                // First try to find the hotel in the current city and rating
                                let selectedHotel = cityHotels[city.city]?.[rating]?.find(h => h.hotel_id === hotelId);
                                
                                // If not found, search in all cities and ratings
                                if (!selectedHotel) {
                                  Object.keys(cityHotels).forEach(cityName => {
                                    Object.keys(cityHotels[cityName] || {}).forEach(ratingValue => {
                                      const foundHotel = cityHotels[cityName][ratingValue].find(h => h.hotel_id === hotelId);
                                      if (foundHotel) {
                                        selectedHotel = foundHotel;
                                      }
                                    });
                                  });
                                }
                                
                                // Use room_types from selectedHotelsMap as a fallback
                                const roomTypes = selectedHotel?.room_types || 
                                                 selectedHotelsMap[`${day.id}-${city.city}-${rating}`]?.room_types || 
                                                 [];
                                
                                // Filter out duplicates and empty values
                                const uniqueRoomTypes = [...new Set(roomTypes.filter(rt => rt && rt.trim() !== ''))];
                                
                                return uniqueRoomTypes.map((roomType, idx) => (
                                  <option 
                                    key={idx} 
                                    value={roomType}
                                  >
                                    {roomType}
                                  </option>
                                ));
                              })()}
                            </select>
                          )}

                              {/* Hotel Types Dropdown */}
                              <select
  className="w-full p-2 border rounded text-sm bg-gray-50"
  value={
    selectedHotelsMap[`${day.id}-${city.city}-${rating}`]?.selectedType ||
    (
      city.activities.find(
        act => act.activity_type === "checkin"
      )?.mealPlan || ''
    )
  }
  onChange={(e) => {
    const type = e.target.value;
    setSelectedHotelsMap(prev => ({
      ...prev,
      [`${day.id}-${city.city}-${rating}`]: {
        ...prev[`${day.id}-${city.city}-${rating}`],
        selectedType: type
      }
    }));
  }}
>
  <option value="">Select Type</option>
  {/* Get types from the selected hotel in cityHotels */}
  {(() => {
    const hotelId = selectedHotelsMap[`${day.id}-${city.city}-${rating}`]?.hotel_id;
    
    // First try to find the hotel in the current city and rating
    let selectedHotel = cityHotels[city.city]?.[rating]?.find(h => h.hotel_id === hotelId);
    
    // If not found, search in all cities and ratings
    if (!selectedHotel) {
      Object.keys(cityHotels).forEach(cityName => {
        Object.keys(cityHotels[cityName] || {}).forEach(ratingValue => {
          const foundHotel = cityHotels[cityName][ratingValue].find(h => h.hotel_id === hotelId);
          if (foundHotel) {
            selectedHotel = foundHotel;
          }
        });
      });
    }
    
    // Use types from selectedHotelsMap as a fallback
    const mealPlanTypes = selectedHotel?.types || 
                         selectedHotelsMap[`${day.id}-${city.city}-${rating}`]?.types || 
                         {};
    
    // Filter available meal plans and sort them
    return Object.entries(mealPlanTypes)
      .filter(([_, isAvailable]) => isAvailable) // Only show available meal plans
      .map(([type], idx) => (
        <option key={idx} value={type}>
          {type}
        </option>
      ));
  })()}
</select>

                            </div>
                          )}
                        </>
                      ) : (
                        <>
                          <select 
  className="w-full p-2 border rounded text-sm"
  value={
    selectedHotelsMap[`${day.id}-${city.city}-${rating}`]?.hotel_id || ""
  }
  onChange={(e) => {
    const hotelId = e.target.value;

    if (hotelId) {
      // Show loading indicator while fetching hotel details
     
      
      // Search for the hotel in all cities and ratings
      let selectedHotel = null;
      let hotelCity = city.city;
      let hotelRating = rating;
      
      // First try to find in the current city and rating
      if (cityHotels[city.city]?.[rating]) {
        selectedHotel = cityHotels[city.city][rating].find(h => h.hotel_id === hotelId);
      }
      
      // If not found, search in all cities and ratings
      if (!selectedHotel) {
        Object.keys(cityHotels).forEach(cityName => {
          Object.keys(cityHotels[cityName] || {}).forEach(ratingValue => {
            const foundHotel = cityHotels[cityName][ratingValue].find(h => h.hotel_id === hotelId);
            if (foundHotel) {
              selectedHotel = foundHotel;
              hotelCity = cityName;
              hotelRating = ratingValue;
            }
          });
        });
      }

      if (selectedHotel) {
        // Get the existing meal plan from activities if available
        const existingMealPlan = city.activities.find(
          act => act.activity_type === "checkin"
        )?.mealPlan || '';

        // Ensure room_types is properly loaded
        const roomTypes = Array.isArray(selectedHotel.room_types) ? selectedHotel.room_types : [];
        
        // Ensure types (meal plans) is properly loaded
        const mealTypes = typeof selectedHotel.types === 'object' ? selectedHotel.types : {};
        
        // Check if the meal plan is available in the hotel's types
        const isExistingMealPlanAvailable = existingMealPlan && 
          mealTypes && 
          mealTypes[existingMealPlan];

        // Log the hotel details for debugging
        console.log(`Selected hotel ${selectedHotel.name} details:`, {
          room_types: roomTypes,
          meal_types: Object.keys(mealTypes),
          main_room_type: selectedHotel.main_room_type || ''
        });

        setSelectedHotelsMap(prev => ({
          ...prev,
          [`${day.id}-${city.city}-${rating}`]: {
            hotel_id: selectedHotel.hotel_id,
            name: selectedHotel.name,
            rating: rating,
            city: hotelCity, // Use the hotel's actual city
            dayId: day.id,
            dayNumber: day.number,
            room_types: roomTypes,
            types: mealTypes,
            main_room_type: selectedHotel.main_room_type || '',
            selectedRoomType: selectedHotel.main_room_type || '',
            selectedType: isExistingMealPlanAvailable ? existingMealPlan : ''
          }
        }));

        console.log("Selected hotel details:", {
          hotel: selectedHotel.name,
          city: hotelCity,
          rating: hotelRating,
          room_types: selectedHotel.room_types || [],
          types: selectedHotel.types || {}
        });
        
        // Hide loading indicator after hotel details are successfully loaded
      
      }
    } else {
      // If no hotel selected, remove it from map
      setSelectedHotelsMap(prev => {
        const newMap = { ...prev };
        delete newMap[`${day.id}-${city.city}-${rating}`];
        return newMap;
      });
    }
  }}
>
  <option value="">Select Hotel</option>
  {/* First show hotels from the current city and rating (prioritized) */}
  {cityHotels[city.city]?.[rating]?.length > 0 && (
    <optgroup label={`${city.city} - ${rating} Star Hotels`}>
      {cityHotels[city.city][rating].map((hotel) => (
        <option key={hotel.hotel_id} value={hotel.hotel_id}>
          {hotel.name}
        </option>
      ))}
    </optgroup>
  )}
  
  {/* Show ALL hotels from ALL cities, categorized by both city and rating */}
  {Object.keys(cityHotels).filter(cityName => 
    // Only include real cities, exclude the current city and special categories
    cityName !== city.city && cityName !== "All Hotels" && cityName !== "Uncategorized"
  ).map(cityName => {
    // For each city, show hotels grouped by rating
    return Object.keys(cityHotels[cityName] || {}).map(ratingValue => {
      const hotelsWithRating = cityHotels[cityName][ratingValue] || [];
      
      return hotelsWithRating.length > 0 && (
        <optgroup key={`${cityName}-${ratingValue}`} label={`${cityName} - ${ratingValue} Star Hotels`}>
          {hotelsWithRating.map((hotel) => (
            <option key={hotel.hotel_id} value={hotel.hotel_id}>
              {hotel.name}
            </option>
          ))}
        </optgroup>
      );
    });
  })}
  
  {/* Show hotels by their city_name with rating */}
  {cityHotels["Uncategorized"] && 
    Object.keys(cityHotels["Uncategorized"] || {}).map(ratingValue => {
      const hotelsWithRating = cityHotels["Uncategorized"][ratingValue] || [];
      
      // Group hotels by city_name
      const hotelsByCity = {};
      hotelsWithRating.forEach(hotel => {
        const cityName = hotel.city_name || "Other";
        if (!hotelsByCity[cityName]) {
          hotelsByCity[cityName] = [];
        }
        hotelsByCity[cityName].push(hotel);
      });
      
      // Create optgroups for each city
      return Object.entries(hotelsByCity).map(([cityName, cityHotels]) => (
        <optgroup key={`${cityName}-${ratingValue}`} label={`${cityName} - ${ratingValue} Star Hotels`}>
          {cityHotels.map((hotel) => (
            <option key={hotel.hotel_id} value={hotel.hotel_id}>
              {hotel.name}
            </option>
          ))}
        </optgroup>
      ));
    })
  }
</select>
                          
                          {/* Loading indicator for hotel details */}
                          {/* {isLoadingHotelDetails && (
                            <div className="flex items-center mt-2 text-blue-500">
                              <i className="fas fa-spinner fa-spin mr-2"></i>
                              <span className="text-sm">Loading hotel details...</span>
                            </div>
                          )} */}
                          
                          {selectedHotelsMap[`${day.id}-${city.city}-${rating}`] && !isLoadingHotelDetails && (
                            <div className="space-y-2 mt-2">
                              {/* Room Types Dropdown */}
                              {selectedHotelsMap[`${day.id}-${city.city}-${rating}`] && (
                                <select
                                  className="w-full p-2 border rounded text-sm bg-gray-50"
                                  value={selectedHotelsMap[`${day.id}-${city.city}-${rating}`]?.selectedRoomType || ''}
                                  onChange={(e) => {
                                    const roomType = e.target.value;
                                    setSelectedHotelsMap(prev => {
                                      // Get current hotel details
                                      const currentHotel = prev[`${day.id}-${city.city}-${rating}`];
                                      if (!currentHotel) return prev;
                                      
                                      return {
                                        ...prev,
                                        [`${day.id}-${city.city}-${rating}`]: {
                                          ...currentHotel,
                                          selectedRoomType: roomType
                                        }
                                      };
                                    });
                                  }}
                                  // Set default value when dropdown is rendered
                                  defaultValue={(() => {
                                    const hotelInfo = selectedHotelsMap[`${day.id}-${city.city}-${rating}`];
                                    return hotelInfo?.main_room_type || '';
                                  })()}
                                >
                                  <option value="">Select Room Type</option>
                                  {/* Room types will be rendered by the function below */}
                                  {/* Get room types from the selected hotel */}
                                  {(() => {
                                    const hotelId = selectedHotelsMap[`${day.id}-${city.city}-${rating}`]?.hotel_id;
                                    let selectedHotel = null;
                                    
                                    // First try to find the hotel in the current city
                                    for (const ratingKey in cityHotels[city.city] || {}) {
                                      const found = cityHotels[city.city][ratingKey]?.find(h => h.hotel_id === hotelId);
                                      if (found) {
                                        selectedHotel = found;
                                        break;
                                      }
                                    }
                                    
                                    // If not found in current city, search all cities
                                    if (!selectedHotel) {
                                      for (const cityName in cityHotels) {
                                        for (const ratingKey in cityHotels[cityName] || {}) {
                                          const found = cityHotels[cityName][ratingKey]?.find(h => h.hotel_id === hotelId);
                                          if (found) {
                                            selectedHotel = found;
                                            break;
                                          }
                                        }
                                        if (selectedHotel) break;
                                      }
                                    }
                                    
                                    // Get room types from the hotel or from the selectedHotelsMap
                                    const roomTypes = selectedHotel?.room_types || 
                                                    selectedHotelsMap[`${day.id}-${city.city}-${rating}`]?.room_types || 
                                                    [];
                                                    
                                    // Get the main_room_type from hotel or selectedHotelsMap
                                    const mainRoomType = selectedHotel?.main_room_type || 
                                                      selectedHotelsMap[`${day.id}-${city.city}-${rating}`]?.main_room_type || 
                                                      '';
                                    
                                    // Filter out duplicates and empty values
                                    let uniqueRoomTypes = [...new Set(roomTypes.filter(rt => rt && rt.trim() !== ''))];
                                    
                                    // Make sure main_room_type appears first by removing it and adding it to the front
                                    if (mainRoomType) {
                                      // Remove main_room_type from the list to avoid duplicates
                                      uniqueRoomTypes = uniqueRoomTypes.filter(rt => rt !== mainRoomType);
                                      // Add main_room_type to the beginning of the array
                                      uniqueRoomTypes.unshift(mainRoomType);
                                    }
                                    
                                    // Log the room types to help with debugging
                                    console.log(`Room types for hotel ${selectedHotel?.name || 'unknown'}:`, uniqueRoomTypes);
                                    console.log(`Main room type: ${mainRoomType}`);
                                    
                                    return uniqueRoomTypes.map((roomType, idx) => (
                                      <option 
                                        key={idx} 
                                        value={roomType}
                                      >
                                        {roomType} {roomType === mainRoomType ? '(Main)' : ''}
                                      </option>
                                    ));
                                  })()}
                                </select>
                              )}

                              {/* Hotel Types Dropdown */}
                              <select
                                className="w-full p-2 border rounded text-sm bg-gray-50"
                                value={
                                  selectedHotelsMap[`${day.id}-${city.city}-${rating}`]?.selectedType ||
                                  (
                                    city.activities.find(
                                      act => act.activity_type === "checkin"
                                    )?.mealPlan || ''
                                  )
                                }
                                onChange={(e) => {
                                  const type = e.target.value;
                                  setSelectedHotelsMap(prev => ({
                                    ...prev,
                                    [`${day.id}-${city.city}-${rating}`]: {
                                      ...prev[`${day.id}-${city.city}-${rating}`],
                                      selectedType: type
                                    }
                                  }));
                                }}
                                // Set default value when dropdown is rendered
                                defaultValue={(() => {
                                  const activityMealPlan = city.activities.find(
                                    act => act.activity_type === "checkin"
                                  )?.mealPlan || '';
                                  return activityMealPlan || '';
                                })()}
                              >
                                <option value="">Select Type</option>
                                {/* Get types from the selected hotel */}
                                {(() => {
                                  const hotelId = selectedHotelsMap[`${day.id}-${city.city}-${rating}`]?.hotel_id;
                                  let selectedHotel = null;
                                  
                                  // First try to find the hotel in the current city
                                  for (const ratingKey in cityHotels[city.city] || {}) {
                                    const found = cityHotels[city.city][ratingKey]?.find(h => h.hotel_id === hotelId);
                                    if (found) {
                                      selectedHotel = found;
                                      break;
                                    }
                                  }
                                  
                                  // If not found in current city, search all cities
                                  if (!selectedHotel) {
                                    for (const cityName in cityHotels) {
                                      for (const ratingKey in cityHotels[cityName] || {}) {
                                        const found = cityHotels[cityName][ratingKey]?.find(h => h.hotel_id === hotelId);
                                        if (found) {
                                          selectedHotel = found;
                                          break;
                                        }
                                      }
                                      if (selectedHotel) break;
                                    }
                                  }
                                  
                                  // Get types from hotel or from selectedHotelsMap
                                  const mealTypes = selectedHotel?.types || 
                                                  selectedHotelsMap[`${day.id}-${city.city}-${rating}`]?.types || 
                                                  {};
                                  
                                  // Get mealPlan from activities
                                  const activityMealPlan = city.activities.find(
                                    act => act.activity_type === "checkin"
                                  )?.mealPlan || '';
                                  
                                  // Log meal types for debugging
                                  console.log(`Meal types for hotel ${selectedHotel?.name || 'unknown'}:`, mealTypes);
                                  console.log(`Activity meal plan: ${activityMealPlan}`);
                                  
                                  // Get available meal types and sort them
                                  const availableMealTypes = Object.entries(mealTypes)
                                    .filter(([_, isAvailable]) => isAvailable)
                                    .map(([type]) => type);
                                  
                                  // If activityMealPlan exists and is available, place it first
                                  if (activityMealPlan && availableMealTypes.includes(activityMealPlan)) {
                                    const filteredTypes = availableMealTypes.filter(type => type !== activityMealPlan);
                                    filteredTypes.unshift(activityMealPlan);
                                    
                                    return filteredTypes.map((type, idx) => (
                                      <option key={idx} value={type}>
                                        {type} {type === activityMealPlan ? '(Default)' : ''}
                                      </option>
                                    ));
                                  }
                                  
                                  return availableMealTypes.map((type, idx) => (
                                    <option key={idx} value={type}>
                                      {type}
                                    </option>
                                  ));
                                })()}
                              </select>
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  </td>
                ))}

              </tr>
            ))
          ))}
        </tbody>
      </table>
    </div>
  </div>
)}
{hasActivities && (
  <div className="mt-4 flex justify-start gap-4">
    {/* Update Itinerary Button */}
 <button
    onClick={postItineraryData}
    className="px-4 py-2 bg-blue-500 text-white rounded-3xl flex items-center justify-center"
    disabled={isSubmitting}
  >
    {isSubmitting ? (
      <span className="flex items-center">
        <i className="fas fa-spinner fa-spin mr-2"></i>
        {editData ? "Updating..." : "Submitting..."}
      </span>
    ) : (
      editData ? "Update Itinerary" : "Save Itinerary"
    )}
  </button>

 {showLoadingOverlay && <LoadingScreen />}


 
<div className="relative">
  <button
    onClick={() => setIsThemeDropdownOpen(!isThemeDropdownOpen)}
    className="px-4 py-2 bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-3xl flex items-center justify-center shadow-md hover:shadow-lg transition-all duration-300 gap-2"
    disabled={isGenerating}
  >
    {isGenerating ? (
      <span className="flex items-center">
        <i className="fas fa-spinner fa-spin mr-2"></i>
        Generating...
      </span>
    ) : (
      <>
        <i className="fas fa-file-alt"></i>
        <span>Generate Itinerary</span>
        <i className="fas fa-chevron-down ml-1 text-xs"></i>
      </>
    )}
  </button>
</div>

{/* Theme Selection Popup */}
{isThemeDropdownOpen && (
  <div 
    className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 transition-opacity duration-300 p-2 sm:p-4 overflow-y-auto"
    onClick={(e) => {
      if (e.target === e.currentTarget) {
        setIsThemeDropdownOpen(false);
      }
    }}
  >
    <div className="bg-white rounded-xl sm:rounded-2xl shadow-2xl max-w-md w-full mx-2 sm:mx-4 my-auto transform transition-all duration-300 scale-100 animate-fadeIn max-h-[95vh] flex flex-col">
      {/* Header */}
      <div className="relative bg-gradient-to-r from-blue-500 via-purple-500 to-blue-600 text-white p-4 sm:p-6 rounded-t-xl sm:rounded-t-2xl flex-shrink-0">
        <button 
          onClick={() => setIsThemeDropdownOpen(false)}
          className="absolute top-3 right-3 sm:top-4 sm:right-4 text-white hover:text-gray-200 transition-colors p-1 sm:p-0"
          aria-label="Close theme selector"
        >
          <i className="fas fa-times text-lg sm:text-xl"></i>
        </button>
        <div className="text-center pr-8 sm:pr-0">
          <i className="fas fa-palette text-2xl sm:text-3xl mb-1 sm:mb-2"></i>
          <h2 className="text-xl sm:text-2xl font-bold">Select Theme</h2>
          <p className="text-blue-100 text-xs sm:text-sm mt-1">Choose your itinerary design</p>
        </div>
      </div>

      {/* Theme Options */}
      <div className="p-3 sm:p-6 space-y-3 sm:space-y-4 overflow-y-auto flex-1">
        <div 
          className={`p-3 sm:p-4 cursor-pointer rounded-lg sm:rounded-xl transition-all duration-300 border-2 flex items-center gap-2 sm:gap-4 group hover:shadow-lg transform hover:-translate-y-1 ${
            selectedTheme === "azure_voyage" 
              ? "bg-blue-50 border-blue-500 shadow-md" 
              : "border-gray-200 hover:border-blue-300 hover:bg-blue-50"
          }`}
          onClick={() => {
            setSelectedTheme("azure_voyage");
            setIsThemeDropdownOpen(false);
            handleGenerateItinerary("azure_voyage");
          }}
        >
          <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-gradient-to-br from-blue-400 to-blue-600 flex items-center justify-center text-white shadow-lg group-hover:scale-110 transition-transform flex-shrink-0">
            <i className="fas fa-water text-sm sm:text-lg"></i>
          </div>
          <div className="flex-1 min-w-0">
            <div className="font-bold text-base sm:text-lg text-gray-800">Azure Voyage</div>
            <div className="text-xs sm:text-sm text-gray-600">Ocean-inspired elegant design with flowing blue elements</div>
          </div>
          {selectedTheme === "azure_voyage" && (
            <div className="text-blue-500 flex-shrink-0">
              <i className="fas fa-check-circle text-lg sm:text-xl"></i>
            </div>
          )}
        </div>

        <div 
          className={`p-3 sm:p-4 cursor-pointer rounded-lg sm:rounded-xl transition-all duration-300 border-2 flex items-center gap-2 sm:gap-4 group hover:shadow-lg transform hover:-translate-y-1 ${
            selectedTheme === "forest_trail" 
              ? "bg-green-50 border-green-500 shadow-md" 
              : "border-gray-200 hover:border-green-300 hover:bg-green-50"
          }`}
          onClick={() => {
            setSelectedTheme("forest_trail");
            setIsThemeDropdownOpen(false);
            handleGenerateItinerary("forest_trail");
          }}
        >
          <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-gradient-to-br from-green-400 to-green-600 flex items-center justify-center text-white shadow-lg group-hover:scale-110 transition-transform flex-shrink-0">
            <i className="fas fa-tree text-sm sm:text-lg"></i>
          </div>
          <div className="flex-1 min-w-0">
            <div className="font-bold text-base sm:text-lg text-gray-800">Forest Trail</div>
            <div className="text-xs sm:text-sm text-gray-600">Nature-inspired serene theme with earthy green tones</div>
          </div>
          {selectedTheme === "forest_trail" && (
            <div className="text-green-500 flex-shrink-0">
              <i className="fas fa-check-circle text-lg sm:text-xl"></i>
            </div>
          )}
        </div>

        <div 
          className={`p-3 sm:p-4 cursor-pointer rounded-lg sm:rounded-xl transition-all duration-300 border-2 flex items-center gap-2 sm:gap-4 group hover:shadow-lg transform hover:-translate-y-1 ${
            selectedTheme === "coastal_breeze" 
              ? "bg-cyan-50 border-cyan-500 shadow-md" 
              : "border-gray-200 hover:border-cyan-300 hover:bg-cyan-50"
          }`}
          onClick={() => {
            setSelectedTheme("coastal_breeze");
            setIsThemeDropdownOpen(false);
            handleGenerateItinerary("coastal_breeze");
          }}
        >
          <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-gradient-to-br from-cyan-400 to-cyan-600 flex items-center justify-center text-white shadow-lg group-hover:scale-110 transition-transform flex-shrink-0">
            <i className="fas fa-umbrella-beach text-sm sm:text-lg"></i>
          </div>
          <div className="flex-1 min-w-0">
            <div className="font-bold text-base sm:text-lg text-gray-800">Coastal Breeze</div>
            <div className="text-xs sm:text-sm text-gray-600">Refreshing beach-inspired design with coastal vibes</div>
          </div>
          {selectedTheme === "coastal_breeze" && (
            <div className="text-cyan-500 flex-shrink-0">
              <i className="fas fa-check-circle text-lg sm:text-xl"></i>
            </div>
          )}
        </div>

        <div 
          className={`p-3 sm:p-4 cursor-pointer rounded-lg sm:rounded-xl transition-all duration-300 border-2 flex items-center gap-2 sm:gap-4 group hover:shadow-lg transform hover:-translate-y-1 ${
            selectedTheme === "emerald_mist" 
              ? "bg-emerald-50 border-emerald-500 shadow-md" 
              : "border-gray-200 hover:border-emerald-300 hover:bg-emerald-50"
          }`}
          onClick={() => {
            setSelectedTheme("emerald_mist");
            setIsThemeDropdownOpen(false);
            handleGenerateItinerary("emerald_mist");
          }}
        >
          <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-gradient-to-br from-emerald-400 to-emerald-600 flex items-center justify-center text-white shadow-lg group-hover:scale-110 transition-transform flex-shrink-0">
            <i className="fas fa-leaf text-sm sm:text-lg"></i>
          </div>
          <div className="flex-1 min-w-0">
            <div className="font-bold text-base sm:text-lg text-gray-800">Emerald Mist</div>
            <div className="text-xs sm:text-sm text-gray-600">Enchanting misty green theme with ethereal elegance</div>
          </div>
          {selectedTheme === "emerald_mist" && (
            <div className="text-emerald-500 flex-shrink-0">
              <i className="fas fa-check-circle text-lg sm:text-xl"></i>
            </div>
          )}
        </div>

        <div 
          className={`p-3 sm:p-4 cursor-pointer rounded-lg sm:rounded-xl transition-all duration-300 border-2 flex items-center gap-2 sm:gap-4 group hover:shadow-lg transform hover:-translate-y-1 ${
            selectedTheme === "vintage_elegance" 
              ? "bg-amber-50 border-amber-500 shadow-md" 
              : "border-gray-200 hover:border-amber-300 hover:bg-amber-50"
          }`}
          onClick={() => {
            setSelectedTheme("vintage_elegance");
            setIsThemeDropdownOpen(false);
            handleGenerateItinerary("vintage_elegance");
          }}
        >
          <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-gradient-to-br from-amber-400 to-amber-600 flex items-center justify-center text-white shadow-lg group-hover:scale-110 transition-transform flex-shrink-0">
            <i className="fas fa-crown text-sm sm:text-lg"></i>
          </div>
          <div className="flex-1 min-w-0">
            <div className="font-bold text-base sm:text-lg text-gray-800">Vintage Elegance</div>
            <div className="text-xs sm:text-sm text-gray-600">Classic refined design with timeless sophistication</div>
          </div>
          {selectedTheme === "vintage_elegance" && (
            <div className="text-amber-500 flex-shrink-0">
              <i className="fas fa-check-circle text-lg sm:text-xl"></i>
            </div>
          )}
        </div>
      </div>

      {/* Footer */}
      <div className="bg-gray-50 px-4 sm:px-6 py-3 sm:py-4 rounded-b-xl sm:rounded-b-2xl border-t border-gray-100 flex-shrink-0">
        <div className="flex flex-col sm:flex-row justify-between items-center gap-2 sm:gap-0">
          <p className="text-xs sm:text-sm text-gray-600 text-center sm:text-left">
            Current: <span className="font-medium text-gray-800">
              {selectedTheme.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
            </span>
          </p>
          <button
            onClick={() => setIsThemeDropdownOpen(false)}
            className="text-xs sm:text-sm text-gray-500 hover:text-gray-700 transition-colors px-3 py-1 sm:px-0 sm:py-0"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
)}

  {documentLink && (
  <a
    href={documentLink}
    download
    className="px-4 py-2 bg-blue-500 text-white rounded-3xl hover:bg-blue-600 flex items-center justify-center"
    onClick={() => {
      setIsDownloading(true); // Show the loading icon
      setTimeout(() => {
        setIsDownloading(false); // Hide the loading icon after a delay
      }, 2000); // Adjust the delay to suit your needs
    }}
  >
    {isDownloading ? (
      <span className="flex items-center">
        <i className="fas fa-spinner fa-spin mr-2"></i>
        Downloading...
      </span>
    ) : (
      "Download Itinerary"
    )}
  </a>
)}


    {/* <button
      onClick={() => {
        // Pass itineraryId if available from editData or state
        const itineraryId = editData?.id || editData?.itinerary_id || null;
        if (itineraryId) {
          navigate('/costing', { state: { itineraryId } });
        } else {
          navigate('/costing');
        }
      }}
      className="px-4 py-2 bg-green-500 text-white rounded-3xl flex items-center justify-center"
      style={{ marginLeft: '1rem' }}
    >
      Go to Costing
    </button> */}
  </div>
)}
   {/* Custom Alert Component */}
<CustomAlert
  isOpen={alertConfig.isOpen}
  onClose={alertConfig.onClose}
  title={alertConfig.title}
  message={alertConfig.message}
  type={alertConfig.type}
  confirmText={alertConfig.confirmText}
  cancelText={alertConfig.cancelText}
  onConfirm={alertConfig.onConfirm}
  showCancel={alertConfig.showCancel}
/>   
    </div>
  );
};

export default DayManager;
